import React, { useEffect, useState } from "react";
import SnpComponent from "../../global/SnpComponent";
import DialogBox from "../../global/DialogBox";
import useAuth from "../../hooks/useAuth";
import {
    BACKEND_BASE_URL, BASE_URL, BillStatus, CustRelationChoice, CustSex, DEL_CUST_BILL, NODATA, OfferType,
    PayMedium, RESYMBOL, RateCardType, SUCCESS, SUCCESSENTIREBILLDEL, TEST_BACKEND_BASE_URL, UPDATEBILL, UiButtonAction, UiGridAction, formatDateInReact, formatDateInSnp, isEmpty, isFeatureAllowed, isNumberEmpty, printDebugLog
} from "../../constants/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import './createBill.css';
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import Loader from "../../global/loader/Loader";
import CustomDataGrid from "../../global/CustomDataGrid";
import EditIcon from "@mui/icons-material/Edit";
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import { INITIAL_BILLDATA, INITIAL_PARTIAL_PAY, INITIAL_SNP_COMPONENT, normalizeCustomer, SEL_ROOM, SINGLE_CUST_FORM, SINGLE_ROOM_DATA } from "../../constants/pojoservice";
import { checkExistingRoomAvailability, deleteRoomFromBill, fetchSingleCustomerData, getBaseBillData, handleDeleteEntireBill, handleDeleteUnpaidDetails, showAvailableRooms, showSingleRoom } from "../createBanquetBill/networkController";
import { addDaysStrDate, addDaysToTodayStrDate, addTimeIfNot, getTime, isSelectedDateStrIsPast, TODAY_FORMAT_DATE } from "../../constants/DateUtils";
import { RoomTableData } from "../component/RoomTableData";
import { ACTUAL_CHECK_IN, ORDER_FROM, ORDER_FROM_ID } from "../../constants/ConfigConstant";
import "dayjs/locale/en-gb";
import DocumentManager from "../drive/DocumentManager";
import { useNotifications } from "../sse/NotificationContext";
import CommonUtils from "../../utilities/CommonUtils";
import { BOOKINGCANCEL, CANCEL_BILL_MANAGEMENT, EPAYBILLING } from "../../constants/Permissions";
import { Search, ArrowUpward } from "@mui/icons-material";
import AadharVerificationBox from "../global/js/AadharVerificationBox";
import { extractFatherName } from "../../constants/commonUtils";

export default function CreateBill() {


    const navigate = useNavigate();
    const location = useLocation();

    const { activeShopHash, authUser, cgstConfig,
        sgstConfig, checkInTimeConfig, configCorporateMeal,
        isInvoiceAllowed, prefixBillName, aadharVerificationEnabled,
        isRoleAllowed } = useAuth();

    const [snpLoader, setSnpLoader] = useState(false);
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);


    const [billData, setBillData] = useState(INITIAL_BILLDATA);
    const [cgst, setCgst] = useState(Number(cgstConfig ?? 2.5)); //2.5 hardcoded for hotel
    const [sgst, setSgst] = useState(Number(sgstConfig ?? 2.5)); //2.5 hardcoded for hotel

    const [partialPay, setPartialPay] = useState(INITIAL_PARTIAL_PAY);
    const [roomData, setRoomData] = useState([]);
    const [selRoom, setSelRoom] = useState(SEL_ROOM);
    const [singleRoomData, setSingleRoomData] = useState(SINGLE_ROOM_DATA);
    const [singleCustData, setSingleCustData] = useState(SINGLE_CUST_FORM);


    const [dialogLoading, setDialogLoading] = useState(false);
    const [spocAdded, setSpocAdded] = useState(false);


    const [gridType, setGridType] = useState(UiGridAction.ROOM); //@UiGridAction

    const [custForm, setCustForm] = useState(0);
    const [roomForm, setRoomForm] = useState(0);
    const [restoForm, setRestoForm] = useState(0);
    const [payForm, setPayForm] = useState(0);
    const [cancelBill, setCancelBill] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [totalDays, setTotalDays] = useState(0);
    const [removedObjects, setRemovedObjects] = useState([]);
    const [updatedRoomList, setUpdatedRoomList] = useState([]);
    const [checkInDateChange, setCheckInDateChange] = useState(false);
    const [changedDate, setChangeDate] = useState("")
    const [showRoomTableDialog, setRoomTableDialog] = useState(false);
    const [selectedRoomId, setSelectedRoomId] = useState("");


    const CORPORATE_MEAL_OBJECT = Array.from(configCorporateMeal, ([key, value]) => ({
        key,
        value
    }));
    const [selectedMeal, setSelectedMeal] = useState(null);
    const [showPaymentListDialog, setShowPaymentListDialog] = useState(false);
    const [keyMapInformation, setKeyMapInformation] = useState(new Map());

    const { subscribe, unsubscribe } = useNotifications();

    //const [columns, setColumns] = useState([]);


    useEffect(() => {
        printDebugLog("CreateBill useEffect", location.state);
        const fieldId = location?.state?.id;
        const viaBill = location?.state?.via_bill;
        const checkInDate = location?.state?.checkInDate ?? TODAY_FORMAT_DATE;
        const checkOutDate = location?.state?.checkOutDate ?? addDaysToTodayStrDate(1);
        if (!isEmpty(fieldId) && !isEmpty(viaBill)) {
            if (viaBill === 0) {
                setSelectedRoomId(fieldId);
                fetchAvailableRooms(0, checkInDate, checkOutDate);
            } else {
                getBillData(fieldId, viaBill);
            }
        }
    }, [location.state]);


    const onSubscribe = (refId) => {
        if (!refId.trim()) return;
        subscribe(refId.trim());
    };

    const onUnsubscribe = (refId) => {
        if (!refId.trim()) return;
        unsubscribe(refId.trim()); // set {serverForce:true} if you also want the server to close it for all
    };

    const convertObjToMap = (obj) => {
        const map = new Map();
        for (const [key, value] of Object.entries(obj)) {
            map.set(key, value && typeof value === "object" && !Array.isArray(value)
                ? convertObjToMap(value)
                : value
            );
        }
        return map;
    };

    const validateIfBillNotInitiated = (mRoomData, isCheckIn, checkInDate, checkOutDate, mTotalDaysStay) => {
        if (billData.totalHotelRoomDetails.length > 0) {
            const listObject = [...billData?.totalHotelRoomDetails];
            if (isCheckIn > 0) {
                setChangeDate(isCheckIn === 1 ? checkInDate : checkOutDate);
                setCheckInDateChange(isCheckIn === 1);
                setTotalDays(mTotalDaysStay);
            }

            const toRemove = [];
            const updatedList = [];
            listObject.forEach(item => {
                const exists = mRoomData.some(room => room.id === item.id);

                if (exists) {
                    updatedList.push(item); // Found → Keep it
                } else {
                    toRemove.push(item); // Not found → Mark for removal
                }
            });
            setUpdatedRoomList(updatedList);
            setRemovedObjects(toRemove);
            if (toRemove.length > 0) {
                setRoomTableDialog(true);
            } else {
                return false;
            }

            return true;
        }
        return false;
    }


    const fetchAvailableRooms = async (isCheckIn, checkInDate, checkOutDate, notSet = false) => {
        await showAvailableRooms({
            authUser: authUser,
            activeShopHash: activeShopHash,
            checkInDate: `${checkInDate} ${getTime()}`,
            checkOutDate: `${checkOutDate} ${getTime()}`,
            mDate: false,
            setLoader: setSnpLoader,
            onResponseCallback: (payLoad, err) => {
                if (err) {
                    setRoomData([]);
                    setSnpComponent(prev => ({
                        ...prev,
                        negativeReq: true,
                        negativeAction: "Dismiss",
                        positiveReq: false,
                        showDialog: true,
                        outSideClickDismiss: true,
                        cancelExtra: true,
                        subTitle: `No Room available at ${checkInDate} to ${checkOutDate}`,
                        handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                    }));
                } else {
                    const mRoomData = payLoad?.data ?? [];
                    setRoomData(mRoomData);
                    const mTotalDaysStay = payLoad?.days ?? 1;
                    if (isCheckIn !== 0 && !validateIfBillNotInitiated(mRoomData, isCheckIn, billData.checkInDate, billData.checkoutDate, mTotalDaysStay)) {
                        if (!notSet) {
                            doTotal(billData.takenDenom, billData.takenOffrAmt, cgst, sgst, billData.gstAllowed, mTotalDaysStay, checkOutDate, checkInDate);
                        }
                    }
                    if (isCheckIn === 0 && !notSet) {
                        doTotal(billData.takenDenom, billData.takenOffrAmt, cgst, sgst, billData.gstAllowed, mTotalDaysStay, checkOutDate, checkInDate);
                    }

                }
            }
        })
    }

    const fetchSingleRoom = async (cellValues) => {
        await showSingleRoom({
            authUser: authUser,
            activeShopHash: activeShopHash,
            roomId: cellValues.row.id,
            setLoader: setSnpLoader,
            onResponseCallback: (payLoad, err) => {
                if (err) {
                    setSnpComponent(prev => ({
                        ...prev,
                        negativeReq: true,
                        negativeAction: "Dismiss",
                        positiveReq: false,
                        showDialog: true,
                        outSideClickDismiss: true,
                        cancelExtra: true,
                        subTitle: `No Room available `,
                        handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                    }));
                } else {
                    showSlectedRoomDetails(payLoad.data, cellValues);
                }
            }
        })
    }

    const checkExistingRoom = async (isCheckinChange, isOnlyDate, cDate) => {
        await checkExistingRoomAvailability({
            authUser: authUser,
            activeShopHash: activeShopHash,
            date: isOnlyDate,
            billId: billData.id,
            checkInDateChange: isCheckinChange,
            changedDate: formatDateInSnp(cDate),
            setLoader: setSnpLoader,
            onResponseCallback: (payLoad, err) => {
                if (!err) {
                    const listRoomNotAvailable = payLoad?.listRoomNotAvailable ?? [];
                    const mTotalDaysStay = payLoad?.days ?? 1;
                    if (listRoomNotAvailable.length > 0 && billData.totalHotelRoomDetails.size > 0) {
                        setChangeDate(cDate);
                        setCheckInDateChange(isCheckinChange);
                        setTotalDays(mTotalDaysStay);
                        const listObject = [...billData?.totalHotelRoomDetails];
                        const toRemove = listObject.filter(item => listRoomNotAvailable.includes(item.id));
                        const updatedList = listObject.filter(item => !listRoomNotAvailable.includes(item.id));
                        setUpdatedRoomList(updatedList);
                        setRemovedObjects(toRemove);
                        setRoomTableDialog(true);
                    } else {
                        if (isCheckinChange) {
                            doTotal(billData.takenDenom, billData.takenOffrAmt, cgst, sgst, billData.gstAllowed, mTotalDaysStay, billData.checkoutDate, cDate);
                        } else {
                            doTotal(billData.takenDenom, billData.takenOffrAmt, cgst, sgst, billData.gstAllowed, mTotalDaysStay, cDate, billData.checkInDate);
                        }
                    }
                }
            }
        })
    }

    const handleFetchAvailableRoom = ({
        isCheckinChange, isOnlyDate, cDate, checkInDate, checkOutDate
    }) => {
        if (isEmpty(billData.id)) {
            fetchAvailableRooms(isCheckinChange ? 1 : 2, checkInDate, checkOutDate);
        } else {
            checkExistingRoom(isCheckinChange, isOnlyDate, cDate);
        }
    }


    const getBillData = async (myParam, viaBill) => {
        await getBaseBillData({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setSnpLoader: setSnpLoader,
            myParam: myParam,
            viaBill: viaBill,
            onResponseCallback: (payLoad, err) => {
                if (!err) {
                    setBillData((prev) => {
                        // Make sure listCustomerDetails exists
                        const list = payLoad?.listCustomerDetails ?? [];

                        // Add index to each item (starting from 1)
                        const updatedList = list.map((item, i) => ({
                            ...item,
                            index: i + 1,
                        }));

                        // Return new state
                        return {
                            ...prev,
                            ...payLoad,
                            listCustomerDetails: updatedList,
                        };
                    });

                    if ((payLoad?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL) {
                        setSnpComponent(prev => ({
                            ...prev,
                            isLoader: false,
                            negativeReq: true,
                            negativeAction: "Home",
                            positiveAction: "Dismiss",
                            positiveReq: true,
                            showDialog: true,
                            outSideClickDismiss: false,
                            cancelExtra: true,
                            subTitle: `This bill is cancelled`,
                            handleSnpCancel: () => navigate("/home"),
                            handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                        }));
                    }
                    setKeyMapInformation(convertObjToMap(payLoad.keyMapInformation))
                    if (!(payLoad?.paymentInitiated ?? false)) {
                        fetchAvailableRooms(0, payLoad.checkInDate, payLoad.checkoutDate, true);
                    }
                    setSpocAdded(payLoad.listCustomerDetailsSize > 0);
                }
            }
        })
    };


    const getCustomerByMobile = async (mob) => {
        await fetchSingleCustomerData({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setSnpLoader: setDialogLoading,
            myParam: mob,
            onLocalMsg: (msg) => {
                setSnpComponent(prev => ({
                    ...prev,
                    isLoader: false,
                    negativeReq: false,
                    positiveAction: "Dismiss",
                    positiveReq: true,
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    subTitle: msg,
                    handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                }));
            },
            onResponseCallback: (payload, error) => {
                if (error) {
                    setSingleCustData((s) =>
                        normalizeCustomer({ ...s, mobNo: mob }, { spocAdded, keepMob: mob })
                    );
                } else {
                    setSingleCustData((s) =>
                        normalizeCustomer({ ...s, ...payload }, { spocAdded, keepMob: mob })
                    );
                }
            }
        })
    };


    // const getCustomerByMobile = async (myParam) => {
    //     if (!authUser)
    //         return;
    //     if (myParam && myParam.length === 10) {
    //         setDialogLoading(true);
    //         let catgUrl =
    //             BACKEND_BASE_URL + GET_CUST_BY_MOB;
    //         let data = {
    //             payLoad: {
    //                 apiToken: authUser.apiToken,
    //                 shopHash: activeShopHash.id,
    //                 mobNo: myParam,
    //             },
    //         };
    //         //console.log("fetchSingleCustomerData => ",data);
    //         axios
    //             .post(catgUrl, data)
    //             .then((response) => {
    //                 setDialogLoading(false);
    //                 //console.log("fetchSingleCustomerData resp=> ", response.data);
    //                 if (response.data.status === SUCCESS)
    //                     setSingleCustData({
    //                         ...singleCustData, ...response.data.payLoad
    //                     });
    //                 else {
    //                     setSnpComponent({
    //                         ...snpComponent, snackBarOpen: true, snackBarMsg: "No Customer found for " + myParam,
    //                     });
    //                     setSingleCustData({
    //                         ...singleCustData,
    //                         id: "",
    //                         custName: "",
    //                         aadharId: "",
    //                         custDob: "",
    //                         emailId: "",
    //                         address: "",
    //                         mobNo: myParam,
    //                         custProfession: "",
    //                         custFatherName: "",
    //                         sex: CustSex.Male,
    //                         relation: spocAdded ? "" : "Spoc",
    //                         choice: spocAdded ? CustRelationChoice.RELATIVE : CustRelationChoice.SPOC,
    //                     });
    //                 }
    //             })
    //             .catch((error) => {
    //                 setDialogLoading(false);
    //                 setSingleCustData({
    //                     ...singleCustData,
    //                     id: "",
    //                     custName: "",
    //                     aadharId: "",
    //                     mobNo: myParam,
    //                     custDob: "",
    //                     emailId: "",
    //                     address: "",
    //                     custProfession: "",
    //                     custFatherName: "",
    //                     sex: CustSex.Male,
    //                     relation: spocAdded ? "" : "Spoc",
    //                     choice: spocAdded ? CustRelationChoice.RELATIVE : CustRelationChoice.SPOC,
    //                 });
    //                 console.log("Error : ", error);
    //                 //window.location.href = "#/error";
    //             });
    //     }
    // };


    const generateSplitBill = async () => {
        try {
            setSnpLoader(true);
            const mUrl = `${BACKEND_BASE_URL}get-split-booking?shopHash=${activeShopHash.id}&id=${CommonUtils.encode(billData.id)}`;
            const response = await axios.get(mUrl);
            printDebugLog("generateSplitBill", response.data);
            if (response.data.status === SUCCESS) {
                const path = response.data.payLoad.printPath;
                if (!isEmpty(path)) {
                    const url = `${BASE_URL}/files/${path}`;
                    window.open(url, '_blank');
                }
            } else {
                const errorMessage = response.data.errorMessage || "Unknown error. Try again.";
                setSnpComponent({
                    ...snpComponent,
                    snackBarOpen: true,
                    snackBarMsg: errorMessage,
                });
            }
            setSnpLoader(false);
        } catch (err) {
            setSnpLoader(false);
            console.log("generateSplitBill" + err);
        }
    }


    const handleSubmitData = (mState, a4Page = false) => {
        if (mState === UiButtonAction.PAY) {
            if (partialPay.partialAmt > 0.0) {
                if (partialPay.payMedium === PayMedium.NOT_SELECTED) {
                    setSnpComponent(prev => ({
                        ...prev,
                        snackBarOpen: true,
                        snackBarMsg: "Please select Payment methods",
                    }))
                    return;
                }
            }
        }
        if (billData.billStatus !== BillStatus.ROOMALLOTEDNOTPAID && cancelBill && mState === UiButtonAction.CANCEL_BILL) {
            if (partialPay.partialAmt > 0.0) {
                if (partialPay.payMedium === PayMedium.NOT_SELECTED) {
                    setSnpComponent(prev => ({
                        ...prev,
                        snackBarOpen: true,
                        snackBarMsg: "Please select Payment methods",
                    }))
                    return;
                }
            }
        }
        if (isEmpty(billData.checkoutDate)) {
            setSnpComponent({
                ...snpComponent, snackBarMsg: "Enter Checkout Date",
                snackBarOpen: true
            });
        } else if (billData.listCustomerDetails.length === 0) {
            setSnpComponent({
                ...snpComponent, snackBarMsg: "Add Customer to Complete Appication",
                snackBarOpen: true
            });
        } else {
            const catgUrl = `${BACKEND_BASE_URL}${UPDATEBILL}`;
            setSnpLoader(true);
            const today = new Date();
            const time = " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    checkInDate: billData.checkInDate + time,
                    checkoutDate: formatDateInSnp(billData.checkoutDate),
                    totalDaysStay: billData.totalDaysStay,
                    bookingId: billData.bookingId,
                    billStatus: billData.billStatus,
                    payMedium: billData.payMedium,
                    onlinePay: billData.onlinePay,
                    cashPay: billData.cashPay,
                    cashTendered: billData.cashTendered,
                    cashReturn: billData.cashReturn,
                    onlineBillPaidThrough: billData.onlineBillPaidThrough,
                    roundOff: billData.roundOff,
                    totalPrice: billData.totalPrice,
                    finalPrice: billData.finalPrice,
                    takenDenom: billData.takenDenom,
                    takenOffrAmt: billData.takenOffrAmt,
                    totalRoomPrice: billData.totalRoomPrice,
                    totalExtraPrice: billData.totalExtraPrice,
                    sgst: sgst,
                    cgst: cgst,
                    cgstAmt: billData.cgstAmt,
                    sgstAmt: billData.sgstAmt,
                    gstAllowed: billData.gstAllowed,
                    totalHotelRoomDetails: billData.totalHotelRoomDetails,
                    listCustomerDetails: billData.listCustomerDetails,
                    state: mState,
                    partialBillAudit: partialPay,
                    remarks: billData.remarks,
                    reason: billData.reason,
                    a4PageRestoReq: a4Page,
                    [ACTUAL_CHECK_IN]: keyMapInformation.get(ACTUAL_CHECK_IN),
                    [ORDER_FROM]: keyMapInformation.get(ORDER_FROM),
                    [ORDER_FROM_ID]: keyMapInformation.get(ORDER_FROM_ID),
                },
            };
            axios
                .post(catgUrl, data)
                .then((response) => {
                    setSnpLoader(false);
                    //console.log("handleSubmitData resp=> ", response.data);
                    if (response.data.status === SUCCESS) {
                        const bookingDetails = response.data.payLoad.bookingDetails;
                        setBillData(prev => ({ ...prev, ...bookingDetails }));
                        if (mState === UiButtonAction.PAY || mState === UiButtonAction.PRINT) {
                            const url = BASE_URL + "/files/" + response.data.payLoad.path;
                            window.open(url, '_blank');
                            getBillData(billData.id, 1);
                        } else if (mState === UiButtonAction.SETTLE) {
                            setSnpComponent(prev => ({
                                ...prev,
                                isLoader: false,
                                negativeReq: true,
                                negativeAction: "Home",
                                positiveAction: "Print",
                                positiveReq: true,
                                showDialog: true,
                                outSideClickDismiss: false,
                                cancelExtra: true,
                                subTitle: "Bill Settled Successfully",
                                handleSnpSubmit: () => {
                                    const url = BASE_URL + "/files/" + response.data.payLoad.path;
                                    window.open(url, '_blank');
                                    //getBillData(billData.roomId);
                                },
                                handleSnpCancel: () => navigate("/home"),
                            }));
                        } else if (mState === UiButtonAction.PAY_WITH_LINK) {
                            onSubscribe(response.data.payLoad.bookingDetails.bookingId);
                            setSnpComponent(prev => ({
                                ...prev,
                                isLoader: false,
                                negativeReq: true,
                                negativeAction: "Book More",
                                positiveAction: "Dismiss",
                                positiveReq: true,
                                showDialog: true,
                                outSideClickDismiss: false,
                                cancelExtra: true,
                                subTitle: `Successfully initiated the payment link for Booking Id: ${response.data.payLoad.bookingDetails.bookingId}`,
                                handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                                handleSnpCancel: () => navigate("/bookroom"),
                            }));
                        } else if (mState === UiButtonAction.CANCEL_BILL) {
                            setSnpComponent(prev => ({
                                ...prev,
                                isLoader: false,
                                negativeReq: true,
                                negativeAction: "Home",
                                positiveAction: "Print",
                                positiveReq: true,
                                showDialog: true,
                                outSideClickDismiss: false,
                                cancelExtra: true,
                                subTitle: `Successfully cancel the Booking Id: ${response.data.payLoad.bookingDetails.bookingId}`,
                                handleSnpCancel: () => navigate("/home"),
                                handleSnpSubmit: () => {
                                    handleSubmitData(UiButtonAction.PRINT);
                                },
                            }));
                        } else {
                            setSnpComponent(prev => ({
                                ...prev,
                                isLoader: false,
                                negativeReq: true,
                                negativeAction: "Book More",
                                positiveAction: "Dismiss",
                                positiveReq: true,
                                showDialog: true,
                                outSideClickDismiss: false,
                                cancelExtra: true,
                                subTitle: `Successfully saved the details for Booking Id: ${response.data.payLoad.bookingDetails.bookingId}`,
                                handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                                handleSnpCancel: () => navigate("/bookroom"),
                            }));
                        }
                    }
                })
                .catch((error) => {
                    setSnpLoader(false);
                    console.log("Error : ", error);
                    //window.location.href = "#/error";
                });
        }
    };


    const doTotal = (mtakenDenom, mTakenOfferAmt, mCgst, mSgst, mGstAllowed, mTotalDays, cOutDate, cInData) => {
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        //Sub total for one day room price
        let mtotalPrice = billData.totalRoomPrice + billData.totalExtraPrice;
        //Sub total for n day room price
        mtotalPrice = mtotalPrice * mTotalDays;

        let mGrandTotal = mtotalPrice;
        let mOfferAmt = Number(mTakenOfferAmt);

        //Checking if any offer for grand total
        if (Number(mtakenDenom) === OfferType.Flat) {
            mGrandTotal = mGrandTotal - mOfferAmt;
        } else if (Number(mtakenDenom) === OfferType.Percentage) {
            mGrandTotal = mGrandTotal
                - ((mGrandTotal * mOfferAmt) / 100);
        } else {
            mOfferAmt = 0.0;
        }

        //Checking if gst allowed for grand total
        if (mGstAllowed) {
            mCgstAmt = (Number(mGrandTotal) * Number(mCgst)) / 100;
            mSgstAmt = (Number(mGrandTotal) * Number(mSgst)) / 100;
            mGrandTotal = Number(mGrandTotal) + Number(mCgstAmt.toFixed(2)) + Number(mSgstAmt.toFixed(2));
        }
        mRoundOff = mGrandTotal.toFixed() - mGrandTotal;
        mGrandTotal = mGrandTotal + mRoundOff;

        //Adding Restaurant bill to Grand Total
        mGrandTotal = mGrandTotal + billData.totalRestaurantBillPrice;
        //Adding Restaurant bill to Sub Total 
        mtotalPrice = mtotalPrice + billData.totalRestaurantBillPrice;
        const parseCheckinDate = addTimeIfNot(cInData, checkInTimeConfig);
        setBillData({
            ...billData,
            takenDenom: mtakenDenom, takenOffrAmt: mOfferAmt,
            cgstAmt: mCgstAmt.toFixed(2), sgstAmt: mSgstAmt.toFixed(2), finalPrice: mGrandTotal.toFixed(2), roundOff: mRoundOff.toFixed(2),
            onlineBillPaidThrough: "", cashPay: 0.0, onlinePay: 0.0, payMedium: -1, cashReturn: 0.0, cashTendered: 0.0,
            gstAllowed: mGstAllowed, totalPrice: mtotalPrice, pendingAmt: mGrandTotal.toFixed(2),
            totalDaysStay: mTotalDays, checkoutDate: cOutDate, checkInDate: parseCheckinDate,
        });
        setCgst(mCgst);
        setSgst(mSgst);
    };

    const handleOnClickRemove = (isRemove) => {
        setRoomTableDialog(false);
        if (isRemove) {
            let mtotalRoomPrice = 0.0;
            let mtotalExtraPrice = 0.0;
            let mCgstAmt = 0.0;
            let mSgstAmt = 0.0;
            let mRoundOff = 0.0;
            let mTotal = 0.0;
            let mtotalPrice = 0.0;

            updatedRoomList.forEach(singleRoomData => {
                mtotalRoomPrice = mtotalRoomPrice + singleRoomData.sAmt;
                mtotalExtraPrice = mtotalExtraPrice + singleRoomData.extraBedFullPrice;
            });
            mtotalPrice = mtotalRoomPrice + mtotalExtraPrice;
            mTotal = mtotalPrice;
            if (Number(billData.takenDenom) === OfferType.Flat) {
                mTotal = mTotal - Number(billData.takenOffrAmt);
            } else if (Number(billData.takenDenom) === OfferType.Percentage) {
                mTotal = mTotal
                    - ((mTotal * Number(billData.takenOffrAmt)) / 100);
            }

            if (billData.gstAllowed) {
                mCgstAmt = (Number(mTotal) * Number(cgst)) / 100;
                mSgstAmt = (Number(mTotal) * Number(sgst)) / 100;
            }
            mTotal = Number(mTotal) + Number(mCgstAmt.toFixed(2)) + Number(mSgstAmt.toFixed(2));
            mRoundOff = mTotal.toFixed() - mTotal;
            mTotal = mTotal + mRoundOff;
            //Calculate Days
            mTotal = mTotal * totalDays;
            mTotal = mTotal + billData.totalRestaurantBillPrice;

            mtotalPrice = mtotalPrice * totalDays;
            mtotalPrice = mtotalPrice + billData.totalRestaurantBillPrice;
            if (checkInDateChange) {
                setBillData(prev => ({
                    ...prev, totalHotelRoomDetails: updatedRoomList,
                    totalRoomPrice: mtotalRoomPrice, totalExtraPrice: mtotalExtraPrice,
                    cgstAmt: mCgstAmt.toFixed(2), sgstAmt: mSgstAmt.toFixed(2), finalPrice: mTotal.toFixed(2), roundOff: mRoundOff.toFixed(2),
                    onlineBillPaidThrough: "", cashPay: 0.0, onlinePay: 0.0, payMedium: -1, cashReturn: 0.0, cashTendered: 0.0,
                    totalPrice: mtotalPrice.toFixed(2), pendingAmt: mTotal.toFixed(2),
                    checkInDate: changedDate,
                }));
            } else {
                setBillData(prev => ({
                    ...prev, totalHotelRoomDetails: updatedRoomList,
                    totalRoomPrice: mtotalRoomPrice, totalExtraPrice: mtotalExtraPrice,
                    cgstAmt: mCgstAmt.toFixed(2), sgstAmt: mSgstAmt.toFixed(2), finalPrice: mTotal.toFixed(2), roundOff: mRoundOff.toFixed(2),
                    onlineBillPaidThrough: "", cashPay: 0.0, onlinePay: 0.0, payMedium: -1, cashReturn: 0.0, cashTendered: 0.0,
                    totalPrice: mtotalPrice.toFixed(2), pendingAmt: mTotal.toFixed(2),
                    checkoutDate: changedDate,
                }));
            }
        } else {
            if (checkInDateChange) {
                setBillData(prev => ({
                    ...prev,
                    checkInDate: changedDate,
                }));
            } else {
                setBillData(prev => ({
                    ...prev,
                    checkoutDate: changedDate,
                }));
            }
        }
    }

    const addHotel = () => {
        let mtotalRoomPrice = billData.totalRoomPrice;
        let mtotalExtraPrice = billData.totalExtraPrice;
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        let mTotal = 0.0;
        let mtotalPrice = 0.0;

        let update = false;
        if (billData.totalHotelRoomDetails.length > 0) {
            var array = [...billData.totalHotelRoomDetails];
            let index = array.findIndex(singleValue => singleValue.id === singleRoomData.id);
            if (index !== -1) {
                update = true;
                let oldtotalRoomPrice = array[index].sAmt;
                let oldtotalExtraPrice = array[index].extraBedFullPrice;
                mtotalRoomPrice = mtotalRoomPrice - oldtotalRoomPrice + singleRoomData.sAmt;
                mtotalExtraPrice = mtotalExtraPrice - oldtotalExtraPrice + singleRoomData.extraBedFullPrice;
                mtotalPrice = mtotalRoomPrice + mtotalExtraPrice;

                mtotalPrice = mtotalPrice * billData.totalDaysStay;

                mTotal = mtotalPrice;
                if (Number(billData.takenDenom) === OfferType.Flat) {
                    mTotal = mTotal - Number(billData.takenOffrAmt);
                } else if (Number(billData.takenDenom) === OfferType.Percentage) {
                    mTotal = mTotal
                        - ((mTotal * Number(billData.takenOffrAmt)) / 100);
                }

                if (billData.gstAllowed) {
                    mCgstAmt = (Number(mTotal) * Number(cgst)) / 100;
                    mSgstAmt = (Number(mTotal) * Number(sgst)) / 100;
                }
                mTotal = Number(mTotal) + Number(mCgstAmt.toFixed(2)) + Number(mSgstAmt.toFixed(2));
                mRoundOff = mTotal.toFixed() - mTotal;
                mTotal = mTotal + mRoundOff;
                //Calculate Days
                //mTotal = mTotal * billData.totalDaysStay;
                mTotal = mTotal + billData.totalRestaurantBillPrice;

                //mtotalPrice = mtotalPrice * billData.totalDaysStay;
                mtotalPrice = mtotalPrice + billData.totalRestaurantBillPrice;


                array[index] = singleRoomData;
                setBillData({
                    ...billData, totalHotelRoomDetails: array,
                    totalRoomPrice: mtotalRoomPrice, totalExtraPrice: mtotalExtraPrice,
                    cgstAmt: mCgstAmt.toFixed(2), sgstAmt: mSgstAmt.toFixed(2), finalPrice: mTotal.toFixed(2), roundOff: mRoundOff.toFixed(2),
                    onlineBillPaidThrough: "", cashPay: 0.0, onlinePay: 0.0, payMedium: -1, cashReturn: 0.0, cashTendered: 0.0,
                    totalPrice: mtotalPrice.toFixed(2), pendingAmt: mTotal.toFixed(2),
                });
            }
        }

        if (!update) {
            mtotalRoomPrice = mtotalRoomPrice + singleRoomData.sAmt;
            mtotalExtraPrice = mtotalExtraPrice + singleRoomData.extraBedFullPrice;
            mtotalPrice = mtotalRoomPrice + mtotalExtraPrice;
            mtotalPrice = mtotalPrice * billData.totalDaysStay;
            mTotal = mtotalPrice;
            if (Number(billData.takenDenom) === OfferType.Flat) {
                mTotal = mTotal - Number(billData.takenOffrAmt);
            } else if (Number(billData.takenDenom) === OfferType.Percentage) {
                mTotal = mTotal
                    - ((mTotal * Number(billData.takenOffrAmt)) / 100);
            }

            if (billData.gstAllowed) {
                mCgstAmt = (Number(mTotal) * Number(cgst)) / 100;
                mSgstAmt = (Number(mTotal) * Number(sgst)) / 100;
            }
            mTotal = Number(mTotal) + Number(mCgstAmt.toFixed(2)) + Number(mSgstAmt.toFixed(2));
            mRoundOff = mTotal.toFixed() - mTotal;
            mTotal = mTotal + mRoundOff;
            //Calculate Days
            //mTotal = mTotal * billData.totalDaysStay;
            mTotal = mTotal + billData.totalRestaurantBillPrice;

            //mtotalPrice = mtotalPrice * billData.totalDaysStay;
            mtotalPrice = mtotalPrice + billData.totalRestaurantBillPrice;

            setBillData(prvsState => ({
                ...prvsState,
                totalHotelRoomDetails: [...prvsState.totalHotelRoomDetails, { ...singleRoomData }],
                totalHotelRoomDetailsSize: billData.totalHotelRoomDetails.length === 0 ? 1 : (billData.totalHotelRoomDetailsSize + 1),
                totalRoomPrice: mtotalRoomPrice, totalExtraPrice: mtotalExtraPrice,
                cgstAmt: mCgstAmt.toFixed(2), sgstAmt: mSgstAmt.toFixed(2), finalPrice: mTotal.toFixed(2), roundOff: mRoundOff.toFixed(2),
                onlineBillPaidThrough: "", cashPay: 0.0, onlinePay: 0.0, payMedium: -1, cashReturn: 0.0, cashTendered: 0.0,
                totalPrice: mtotalPrice.toFixed(2),
                pendingAmt: mTotal.toFixed(2),
            }));
        }

        var rArray = [...roomData];
        let index = rArray.findIndex(singleValue => singleValue.id === singleRoomData.id);
        rArray[index].sel = true;
        setRoomData(rArray);
    }

    const handleSubmitDialog = (mState) => {
        //console.log("handleSubmitDialog" )
        if (custForm === 1) {
            //console.log("handleSubmitDialog" ,singleCustData)
            let ok = true;
            if (singleCustData.choice === CustRelationChoice.SPOC && isEmpty(singleCustData.mobNo)) {
                ok = false;
            }
            if (ok && !isEmpty(singleCustData.custName)) {
                let update = false;
                if (billData.listCustomerDetailsSize > 0) {
                    let array = [...billData.listCustomerDetails];
                    let index = array.findIndex(singleValue => singleValue.index === singleCustData?.index ?? -1);
                    if (index !== -1) {
                        update = true;

                        array[index] = singleCustData;
                        setBillData({
                            ...billData, listCustomerDetails: array,
                        });
                    }
                }
                if (!update) {
                    let array = [...billData.listCustomerDetails];
                    const lastIndex = array.length > 0 ? array[array.length - 1].index || 0 : 0;
                    const newIndex = lastIndex + 1;
                    if (spocAdded) {

                        const newItem = {
                            ...singleCustData,
                            choice: CustRelationChoice.RELATIVE,
                            index: newIndex
                        };
                        setBillData(prvsState => ({
                            ...prvsState,
                            listCustomerDetails: [...prvsState.listCustomerDetails, newItem],
                            listCustomerDetailsSize: (prvsState.listCustomerDetailsSize + 1)
                        }));
                    } else {
                        setSpocAdded(true);

                        const newItem = {
                            ...singleCustData,
                            choice: CustRelationChoice.SPOC,
                            index: newIndex
                        };

                        setBillData(prvsState => ({
                            ...prvsState,
                            listCustomerDetails: [...prvsState.listCustomerDetails, newItem],
                            listCustomerDetailsSize: (prvsState.listCustomerDetailsSize + 1)
                        }));
                    }
                }
                //Focussing on Current Added Data
                setGridType(1);
                handleDialogClose();
            } else {
                setSnpComponent({
                    ...snpComponent,
                    snackBarMsg:
                        singleCustData.choice === CustRelationChoice.SPOC ? "Enter minimum details to submit i.e. Mobile number & Customer Name" : "Enter minimum details to submit i.e. Customer Name",
                    snackBarOpen: true,
                })
            }
        } else if (roomForm === 1) {
            if (!isEmpty(singleRoomData.id)) {
                addHotel();
                //Focussing on Current Added Data
                setGridType(0);
                handleDialogClose();
            } else {
                setSnpComponent({
                    ...snpComponent,
                    snackBarMsg: "No Room Selected...",
                    snackBarOpen: true,
                })
            }

        } else if (payForm === 1) {
            handleSubmitData(mState);
            handleDialogClose();
        }

    };

    const handleDialogClose = () => {
        setCustForm(0);
        setRoomForm(0);
        setRestoForm(0);
        setPayForm(0);
        setIsEdit(false);
        setDialogLoading(false);
        setSingleCustData({
            ...SINGLE_CUST_FORM,
            choice: spocAdded ? CustRelationChoice.RELATIVE : CustRelationChoice.SPOC,
        });
        setSelRoom(SEL_ROOM);
        setSingleRoomData(SINGLE_ROOM_DATA);
        setSelectedMeal(null);
        setCancelBill(false);
        if (!billData.paymentInitiated && billData.billStatus === BillStatus.ROOMALLOTEDPARTIALPAID) {
            setBillData({
                ...billData, billStatus: BillStatus.ROOMALLOTEDNOTPAID,
            })
        }
        setShowPaymentListDialog(false);
        setPartialPay(INITIAL_PARTIAL_PAY);
    };

    const custDelSnippet = (mobNo) => {
        setBillData((prev) => {
            const updatedList = prev.listCustomerDetails.filter(
                (item) => item.mobNo !== mobNo
            );

            const kSpocAdded = updatedList.length > 0;

            setSpocAdded(kSpocAdded);
            setSingleCustData({
                ...SINGLE_CUST_FORM,
                choice: kSpocAdded ? CustRelationChoice.RELATIVE : CustRelationChoice.SPOC,
            });

            return {
                ...prev,
                listCustomerDetails: updatedList,
                listCustomerDetailsSize: updatedList.length,
            };
        });
    };


    const roomDelSnippet = (roomDataId) => {
        var array = [...billData.totalHotelRoomDetails];
        const index = array.findIndex(singleValue => singleValue.rateId === roomDataId);
        if (index !== -1) {
            const deletedRoomData = array[index];
            if (!deletedRoomData) {
                printDebugLog("roomDelSnippet", `Cannot able to delete room for id ${roomDataId}`)
                return;
            }
            array.splice(index, 1);

            let mCgstAmt = 0.0;
            let mSgstAmt = 0.0;
            let mRoundOff = 0.0;

            let mTroomPrice = billData.totalRoomPrice - deletedRoomData.totalRoomPrice;
            let mTextraBedPrice = billData.totalExtraPrice - deletedRoomData.extraBedFullPrice;

            //Sub total for one day room price
            let mtotalPrice = mTroomPrice + mTextraBedPrice;
            //Sub total for n day room price
            mtotalPrice = mtotalPrice * billData.totalDaysStay;

            let mGrandTotal = mtotalPrice;
            //Checking if any offer for grand total
            if (Number(billData.takenDenom) === OfferType.Flat) {
                mGrandTotal = mGrandTotal - billData.takenOffrAmt;
            } else if (Number(billData.takenDenom) === OfferType.Percentage) {
                mGrandTotal = mGrandTotal
                    - ((mGrandTotal * billData.takenOffrAmt) / 100);
            }

            //Checking if gst allowed for grand total
            if (billData.gstAllowed) {
                mCgstAmt = (Number(mGrandTotal) * Number(cgst)) / 100;
                mSgstAmt = (Number(mGrandTotal) * Number(sgst)) / 100;
                mGrandTotal = Number(mGrandTotal) + Number(mCgstAmt.toFixed(2)) + Number(mSgstAmt.toFixed(2));
            }
            mRoundOff = mGrandTotal.toFixed() - mGrandTotal;
            mGrandTotal = mGrandTotal + mRoundOff;

            //Adding Restaurant bill to Grand Total
            mGrandTotal = mGrandTotal + billData.totalRestaurantBillPrice;
            //Adding Restaurant bill to Sub Total 
            mtotalPrice = mtotalPrice + billData.totalRestaurantBillPrice;
            setBillData(prev => ({
                ...prev,
                cgstAmt: mCgstAmt.toFixed(2), sgstAmt: mSgstAmt.toFixed(2), finalPrice: mGrandTotal.toFixed(2), roundOff: mRoundOff.toFixed(2),
                onlineBillPaidThrough: "", cashPay: 0.0, onlinePay: 0.0, payMedium: -1, cashReturn: 0.0, cashTendered: 0.0,
                totalPrice: mtotalPrice, pendingAmt: mGrandTotal.toFixed(2),
                totalRoomPrice: mTroomPrice, totalExtraPrice: mTextraBedPrice,
                totalHotelRoomDetails: array,
                totalHotelRoomDetailsSize: array.length,
            }));
        }
    };

    const handleDeleteCustomer = (custData) => {
        console.log("handleDeleteCustomer", custData);
        if (custData.choice === CustRelationChoice.SPOC) {
            setSnpComponent({
                ...snpComponent,
                snackBarMsg: "Spoc cannot be deleted. Please Edit the details",
                snackBarOpen: true,
            });
        } else {
            if (isEmpty(billData.id)) {
                custDelSnippet(custData.mobNo);
            } else {
                let no = "";
                let dets = "";
                if (!isEmpty(custData.mobNo)) {
                    no = "1";
                    dets = custData.mobNo;
                } else {
                    if (!isEmpty(custData.aadharId)) {
                        no = "2";
                        dets = custData.aadharId;
                    } else if (!isEmpty(custData.custName)) {
                        no = "3";
                        dets = custData.custName;
                    }
                }

                let deleteUrl = BACKEND_BASE_URL + DEL_CUST_BILL + "/" + billData.id + "/" + no + "/" + dets;
                let data = {};
                setSnpLoader(true);
                axios.get(
                    deleteUrl,
                    data
                )
                    .then((response) => {
                        //printLog("response  => ", response.data.jcJson);
                        setSnpLoader(false);
                        if (response.data === SUCCESS)
                            getBillData(billData.roomId, 0);
                        else if (response.data === NODATA)
                            custDelSnippet(custData.mobNo);
                        else
                            console.log("handleDeleteCustomer resp: ", response.data);
                    }).catch((error) => {
                        setSnpLoader(false);
                        //printLog("errr ", error);
                        //window.location.href = "#/error";
                    });
            }
        }
    };

    const handleDeleteRoom = async (roomData) => {
        console.log("handleDeleteRoom", roomData, billData);
        if (isEmpty(billData.id))
            roomDelSnippet(roomData.rateId);
        else {
            await deleteRoomFromBill({
                authUser: authUser,
                activeShopHash: activeShopHash,
                mRoom: roomData.id,
                mBillId: billData.id,
                setSnpLoader: setSnpLoader,
                onResponseCallback: (status) => {
                    if (status === SUCCESS) {
                        getBillData(billData.id, 1);
                    } else if (status === SUCCESSENTIREBILLDEL) {
                        setSnpComponent(prev => ({
                            ...prev,
                            isLoader: false,
                            negativeReq: true,
                            negativeAction: "Home",
                            positiveAction: "",
                            positiveReq: false,
                            showDialog: true,
                            outSideClickDismiss: false,
                            cancelExtra: true,
                            subTitle: "As there is no room in bill bucket, so entire Bill is deleted automatically",
                            handleSnpCancel: () => navigate("/home"),
                        }));
                    }
                    else if (status === NODATA) {
                        roomDelSnippet(roomData.rateId);
                    } else {
                        console.log("handleDeleteRoom resp: ", status);
                    }
                }
            })
        }
    };

    const handlePermanentDelete = async () => {
        await handleDeleteEntireBill({
            activeShopHash: activeShopHash,
            id: billData.id,
            setSnpLoader: setSnpLoader,
            setSnpComponent: setSnpComponent,
            navigate: navigate
        })
    }

    const handlePermanentDeleteUnpaidBill = async (id) => {
        await handleDeleteUnpaidDetails({
            authUser: authUser,
            setSnpLoader: setSnpLoader,
            activeShopHash: activeShopHash,
            id: id,
            setSnpComponent: setSnpComponent,
            navigate: navigate,
            handleSuccess: () => getBillData(billData.id, 1),
        })
    };

    const deleteEntireBill = async () => {
        if (isEmpty(billData.id)) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarMsg: "Still Bill not created",
                snackBarOpen: true,
            }));
            return;
        }

        setSnpComponent(prev => ({
            ...prev,
            isLoader: false,
            negativeReq: true,
            negativeAction: "Dismiss",
            positiveAction: "Yes delete",
            positiveReq: true,
            showDialog: true,
            outSideClickDismiss: false,
            cancelExtra: true,
            subTitle: `Are you sure want to delete Booking : ${billData.bookingId}`,
            handleSnpSubmit: () => handlePermanentDelete(),
            handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
        }));

    };

    const showSlectedRoomDetails = (roomDets, cellValues,) => {
        if (!isEmpty(roomDets)) {
            setRoomForm(1);
            setIsEdit(true);
            setSelRoom(roomDets);
            setSingleRoomData(prev => ({
                ...prev, ...cellValues.row,
            }))
            const mealType = cellValues.row.mealType ?? "";
            const mealPrice = Number(cellValues.row.mealPrice ?? 0);
            if (!isEmpty(mealType)) {
                setSelectedMeal({ key: mealType, value: mealPrice });
            }
        } else {
            console.log("columnHotelDetails ", roomDets);
            fetchSingleRoom(cellValues);
        }
    }

    const GRIDARRAY = [
        "Selected Room Details", "Customer Details", "Order Food Bill Details"
    ]

    const COLUMN_CUSTOMER = [
        { field: "custName", headerName: "Customer Name", width: 150 },
        { field: "mobNo", headerName: "Mob", width: 150 },
        { field: "relation", headerName: "Relation", width: 150 },
        {
            field: "Edit",
            headerName: "Edit",
            width: 70,
            renderCell: (cellValues) => {
                return (
                    <EditIcon
                        onClick={(event) => {
                            //console.log("COLUMN_CUSTOMER ",cellValues.row);
                            setCustForm(1);
                            setIsEdit(true);
                            setSingleCustData({
                                ...singleCustData, ...cellValues.row,
                            })
                        }}
                    ></EditIcon>
                );
            },
        },
        {
            field: "del",
            headerName: "Del",
            flex: 1,
            renderCell: (cellValues) => {
                return (
                    <DeleteIcon style={{ cursor: "pointer" }}
                        onClick={(event) => {
                            if (billData.paymentInitiated) {
                                setSnpComponent({
                                    ...snpComponent,
                                    snackBarMsg: "Paid bill cannot be deleted",
                                    snackBarOpen: true,
                                });
                                return;
                            }
                            if (billData.billStatus === BillStatus.CANCELLED_BILL) {
                                setSnpComponent(prev => ({
                                    ...prev, snackBarMsg: "Canncelled bill cannot be deleted.", snackBarOpen: true,
                                }));
                                return;
                            }
                            handleDeleteCustomer(cellValues.row);
                        }}
                    >
                    </DeleteIcon>
                );
            }
        },
    ];

    const COLUMN_RESTO = [
        { field: "billNo", headerName: "Bill No", width: 110 },
        { field: "salePerson", headerName: "Sale Person", width: 150 },
        { field: "totalPrice", headerName: "T.Amt", width: 150 },
        { field: "status", headerName: "Status", width: 150 },
        { field: "on", headerName: "On", width: 160 },
    ];



    const COLUMN_HOTELS = [
        { field: "name", headerName: "Room Details", width: 250 },
        { field: "extraBedQuan", headerName: "ExtraBed Quan", width: 110 },
        { field: "totalRoomPrice", headerName: "T.Amt", width: 90 },
        {
            field: "Edit",
            headerName: "Edit",
            width: 70,
            renderCell: (cellValues) => {
                return (
                    <EditIcon
                        onClick={() => {
                            //console.log("columnHotelDetails ",mRoomData);
                            if (billData.billStatus === BillStatus.CANCELLED_BILL) {
                                setSnpComponent(prev => ({
                                    ...prev, snackBarMsg: "Canncelled bill cannot be edited.", snackBarOpen: true,
                                }));
                                return;
                            }
                            if (billData.paymentInitiated) {
                                fetchSingleRoom(cellValues);
                            } else {
                                const roomDets = roomData.find(item => item.id === cellValues.row.id);
                                showSlectedRoomDetails(roomDets, cellValues);
                            }

                            //console.log("COLUMN_CUSTOMER ",roomDets);

                        }}
                    ></EditIcon>
                );
            },
        },
        {
            field: "del",
            headerName: "Del",
            width: 70,
            renderCell: (cellValues) => {
                return (
                    <DeleteIcon style={{ cursor: "pointer" }}
                        onClick={(event) => {
                            if (billData.paymentInitiated) {
                                setSnpComponent({
                                    ...snpComponent,
                                    snackBarMsg: "Paid bill cannot be deleted",
                                    snackBarOpen: true,
                                });
                                return;
                            }
                            if (billData.billStatus === BillStatus.CANCELLED_BILL) {
                                setSnpComponent(prev => ({
                                    ...prev, snackBarMsg: "Canncelled bill cannot be deleted.", snackBarOpen: true,
                                }));
                                return;
                            }
                            setSnpComponent(prev => ({
                                ...prev,
                                isLoader: false,
                                negativeReq: true,
                                negativeAction: "Dismiss",
                                positiveAction: "Delete",
                                positiveReq: true,
                                showDialog: true,
                                outSideClickDismiss: false,
                                cancelExtra: true,
                                subTitle: "Do you want to delete room " + cellValues.row.name,
                                handleSnpSubmit: () => {
                                    setSnpComponent(INITIAL_SNP_COMPONENT);
                                    handleDeleteRoom(cellValues.row);
                                },
                                handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                            }));
                        }}
                    >
                    </DeleteIcon>
                );
            }
        },
        {
            field: "",
            flex: 1,
            renderCell: (cellValues) => {
                const mealType = cellValues.row.mealType;
                const mealPrice = cellValues.row.mealPrice;

                if (!isEmpty(mealType)) {
                    return (
                        <span>
                            Included {mealType}: {RESYMBOL} {mealPrice}
                        </span>
                    );
                }

                return <span></span>;
            },
        },
    ];

    const putFirstRoomData = (option) => {
        setSelRoom(prev => ({
            ...prev, ...option
        }));
        const firstPrice = option.priceList[0];
        setSingleRoomData(prev => ({
            ...prev, id: option.id, name: option.name,
            type: Number(firstPrice.type),
            rateId: firstPrice.id, sAmt: firstPrice.sAmt, extraBedPrice: 0.0,
            extraBedQuan: 0, rateName: firstPrice.name, totalRoomPrice: firstPrice.sAmt, extraBedFullPrice: 0.0
        }));
    }

    const selectFirstRoom = () => {
        if (billData.totalHotelRoomDetails.length === 0 && !isEmpty(selectedRoomId)) {
            const index = roomData.findIndex(singleValue => singleValue.id === selectedRoomId);
            if (index > -1) {
                putFirstRoomData(roomData[index]);
            } else {
                setSelectedRoomId("");
                setBillData(prev => ({
                    ...prev, totalHotelRoomDetailsSize: 0,
                }))
            }
        }
        setRoomForm(1);
    };

    const renderRoomDialogContent = () => {
        return (
            <>
                <Box className="room-main">
                    <Grid container spacing={1}
                        justifyContent="center"
                        alignItems="center" sx={{
                            padding: 0, margin: 0,
                        }} >
                        {
                            !isEdit && <Grid item xs={12} md={7} sm={7}>
                                <Autocomplete
                                    id="room-select"
                                    options={roomData}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    onChange={(e, option) => {
                                        //console.log("room-select",option);
                                        if (option) {
                                            putFirstRoomData(option);
                                        } else {
                                            setSelRoom(SEL_ROOM);
                                            setSingleRoomData(SINGLE_ROOM_DATA);
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionLabel={(option) => option.name}
                                    defaultValue={selRoom}
                                    renderOption={(props, option) => (
                                        !option.sel && <Box
                                            component="li"
                                            {...props}
                                        >
                                            {option.name}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Room"
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }
                        {
                            selRoom.priceList.length > 0 && <Grid item xs={12} md={12} sm={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Rate Card</FormLabel>
                                    <RadioGroup aria-label="rate-select" name="rate-select" value={singleRoomData.rateId} onChange={(e) => {
                                        //let roomDets = [...selRoom.priceList].find(item => item.id === e.target.id);
                                        //console.log("rate-select",e.target,singleRoomData,selRoom.priceList);
                                        const data = JSON.parse(e.target.name);
                                        setSingleRoomData(prev => ({
                                            ...prev, rateId: e.target.value, sAmt: Number(e.target.id), rateName: data.name,
                                            type: Number(data.type),
                                            totalRoomPrice: Number(e.target.id),
                                            extraBedPrice: 0.0,
                                            extraBedQuan: 0, extraBedFullPrice: 0.0,
                                            mealType: "", mealPrice: 0,
                                        }));
                                    }}>
                                        {selRoom.priceList.map((data) => (
                                            <div>
                                                <FormControlLabel control={<Radio
                                                    value={data.id}
                                                    name={JSON.stringify(data)}
                                                    id={data.sAmt}
                                                />}
                                                    label={`${data.name ?? ""} Amount: ${RESYMBOL} ${data.sAmt} ${data.type === RateCardType.HOTEL_CORPORATE ? "(Corporate)" : ""}`} />
                                            </div>
                                        ))}
                                    </RadioGroup>
                                </FormControl>

                            </Grid>
                        }
                        {
                            singleRoomData.type === RateCardType.HOTEL_CORPORATE &&
                            <Grid item xs={12} md={7} sm={12}>
                                <Autocomplete
                                    id="meal-select"
                                    options={CORPORATE_MEAL_OBJECT}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    getOptionLabel={(option) => option.key}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.key} : ₹ {option.value}
                                        </li>
                                    )}
                                    value={selectedMeal}
                                    onChange={(event, newValue, reason, details) => {
                                        //console.log("CORPORATE_MEAL_OBJECT", newValue, reason, details);
                                        setSelectedMeal(newValue);
                                        const eMealPrice = Number(newValue?.value ?? 0);
                                        const oldPrice = Number(singleRoomData?.mealPrice ?? 0);
                                        const sAmt = singleRoomData.sAmt + eMealPrice - oldPrice;
                                        const tPrice = singleRoomData.totalRoomPrice + eMealPrice - oldPrice;

                                        setSingleRoomData(prev => ({
                                            ...prev, mealType: newValue ? newValue.key : "",
                                            mealPrice: eMealPrice, totalRoomPrice: tPrice,
                                            sAmt: sAmt,
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Meal" variant="outlined" />
                                    )}
                                />
                            </Grid>
                        }
                        {
                            !isEmpty(singleRoomData.rateId) && <Grid item xs={12} md={6} sm={6}>
                                <TextField
                                    id="extraBedQuan"
                                    label="Enter Quantity"
                                    type="number"
                                    name="extraBedQuan"
                                    value={singleRoomData.extraBedQuan}
                                    variant="filled"
                                    size="small"
                                    helperText="Quantity for Extra Bed"
                                    onChange={(e) => {
                                        if (!isNumberEmpty(e.target.value)) {
                                            const val = Number(e.target.value);
                                            const eFullPrice = (val * singleRoomData.extraBedPrice);
                                            const tPrice = singleRoomData.sAmt + eFullPrice;
                                            setSingleRoomData(prev => ({
                                                ...prev, extraBedQuan: val, totalRoomPrice: tPrice, extraBedFullPrice: eFullPrice,
                                            }));
                                        } else {
                                            const eFullPrice = (0 * singleRoomData.extraBedPrice);
                                            const tPrice = singleRoomData.sAmt + eFullPrice;
                                            setSingleRoomData(prev => ({
                                                ...prev, extraBedQuan: 0, totalRoomPrice: tPrice, extraBedFullPrice: eFullPrice,
                                            }));
                                        }
                                    }}
                                    fullWidth
                                    inputProps={{ min: '0' }}
                                />
                            </Grid>
                        }
                        {
                            !isEmpty(singleRoomData.rateId) && <Grid item xs={12} md={6} sm={6}>
                                <TextField
                                    id="extraBedPrice"
                                    label="Enter Price"
                                    type="number"
                                    name="extraBedPrice"
                                    value={singleRoomData.extraBedPrice}
                                    variant="filled"
                                    size="small"
                                    helperText="Price for Extra Bed/per"
                                    onChange={(e) => {
                                        if (!isNumberEmpty(e.target.value)) {
                                            let val = Number(e.target.value);
                                            let eFullPrice = (singleRoomData.extraBedQuan * val);
                                            let tPrice = singleRoomData.sAmt + eFullPrice;
                                            setSingleRoomData(prev => ({
                                                ...prev, extraBedPrice: val, totalRoomPrice: tPrice, extraBedFullPrice: eFullPrice,
                                            }));
                                        } else {
                                            setSingleRoomData(prev => ({
                                                ...prev, extraBedPrice: 0, totalRoomPrice: singleRoomData.sAmt, extraBedFullPrice: 0,
                                            }));
                                        }
                                    }}
                                    fullWidth
                                    inputProps={{ min: '0' }}
                                />
                            </Grid>
                        }
                        {
                            !isEmpty(singleRoomData.rateId) && <Grid item xs={12} md={9} sm={9}>
                                <Typography variant="p" style={{ fontSize: "19px", color: "#2f1160" }}>
                                    Total Amount :
                                    {singleRoomData.extraBedQuan !== 0 && " " + singleRoomData.sAmt + " + " + singleRoomData.extraBedQuan +
                                        " x " + singleRoomData.extraBedPrice + " = "
                                    }   &#8377; {singleRoomData.totalRoomPrice}
                                </Typography>
                            </Grid>
                        }
                    </Grid>
                </Box>
            </>
        );
    }

    const renderCustDialogContent = () => {
        return (
            <>
                <div>
                    {
                        dialogLoading ? <Loader /> : <Grid container spacing={1}>
                            <Grid item md={12} sm={12} xs={12}>
                                <FormLabel component="legend">Select Customer Selection</FormLabel>
                                <RadioGroup row aria-label="choice" name="choice" value={singleCustData.choice} onChange={(e) => setSingleCustData({
                                    ...singleCustData, choice: Number(e.target.value), relation: (Number(e.target.value) === CustRelationChoice.SPOC ? "Spoc" : ""),
                                })} >
                                    <FormControlLabel disabled={isEdit || spocAdded} value={CustRelationChoice.SPOC} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label="Spoc" />
                                    <FormControlLabel disabled={isEdit || !spocAdded} value={CustRelationChoice.RELATIVE} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label="Family/Friends" />
                                </RadioGroup>
                            </Grid>
                            {
                                aadharVerificationEnabled &&
                                <Grid item xs={12} md={6}>
                                    <AadharVerificationBox
                                        BACKEND_BASE_URL={BACKEND_BASE_URL}
                                        authUser={authUser}
                                        activeShopHash={activeShopHash}
                                        onVerified={(payLoad) => {
                                            setSingleCustData(prev => ({
                                                ...prev,
                                                custDob: payLoad.dob,
                                                sex: "M" === payLoad.gender
                                                    ? CustSex.Male
                                                    : "F" === payLoad.gender
                                                        ? CustSex.Female
                                                        : CustSex.Other,
                                                custPhoto: `data:image/jpeg;base64,${payLoad.photo_link}`,
                                                custName: payLoad.name,
                                                custFatherName: extractFatherName(payLoad.care_of),
                                                address: `${payLoad.care_of},${payLoad.address}`,
                                                emailId: payLoad.email,
                                            }));
                                        }} />
                                </Grid>
                            }
                            {!isEmpty(singleCustData.custPhoto) && (
                                <Grid item xs={12} display="flex" justifyContent="center">
                                    <img
                                        src={singleCustData.custPhoto}
                                        alt="Customer"
                                        style={{
                                            width: 240,
                                            height: 240,
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                        }}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} md={6} sm={12}>
                                <TextField
                                    required
                                    id="mobNo"
                                    label="Enter Mob No"
                                    name="mobNo"
                                    variant="filled"
                                    size="small"
                                    defaultValue={singleCustData.mobNo}
                                    onChange={(e) => {
                                        setSingleCustData({
                                            ...singleCustData, mobNo: e.target.value,
                                        });
                                        getCustomerByMobile(e.target.value);
                                    }}
                                    inputProps={{
                                        maxLength: 10,
                                        inputMode: "numeric",
                                        pattern: "[0-9]*"
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={12}>
                                <TextField
                                    required
                                    id="custName"
                                    label="Enter Customer Name"
                                    name="custName"
                                    variant="filled"
                                    size="small"
                                    defaultValue={singleCustData.custName}
                                    onChange={(e) => setSingleCustData({
                                        ...singleCustData, custName: e.target.value,
                                    })}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6} sm={12} xs={12}>
                                <FormLabel component="legend">Select Gender</FormLabel>
                                <RadioGroup row aria-label="sex" name="sex" value={singleCustData.sex} onChange={(e) => setSingleCustData({
                                    ...singleCustData, sex: e.target.value,
                                })} >
                                    <FormControlLabel value={CustSex.Male} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={CustSex.Male} />
                                    <FormControlLabel value={CustSex.Female} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={CustSex.Female} />
                                    <FormControlLabel value={CustSex.Other} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={CustSex.Other} />
                                </RadioGroup>
                            </Grid>
                            {
                                singleCustData.choice === CustRelationChoice.SPOC && <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="emailId"
                                        label="Enter Email"
                                        name="emailId"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.emailId}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, emailId: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }

                            {
                                !aadharVerificationEnabled &&
                                <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="aadharId"
                                        label="Enter Aadhar"
                                        name="aadharId"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.aadharId}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, aadharId: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }


                            <Grid item xs={12} md={6} sm={12}>
                                <TextField
                                    id="drivingLicense"
                                    label="Enter Driving License"
                                    name="drivingLicense"
                                    variant="filled"
                                    size="small"
                                    defaultValue={singleCustData.drivingLicense}
                                    onChange={(e) => setSingleCustData({
                                        ...singleCustData, drivingLicense: e.target.value,
                                    })}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={12}>
                                <TextField
                                    id="panNo"
                                    label="Enter Pan No"
                                    name="panNo"
                                    variant="filled"
                                    size="small"
                                    defaultValue={singleCustData.panNo}
                                    onChange={(e) => setSingleCustData({
                                        ...singleCustData, panNo: e.target.value,
                                    })}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={12}>
                                <TextField
                                    id="voterId"
                                    label="Enter Voter Id"
                                    name="voterId"
                                    variant="filled"
                                    size="small"
                                    defaultValue={singleCustData.voterId}
                                    onChange={(e) => setSingleCustData({
                                        ...singleCustData, voterId: e.target.value,
                                    })}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={12}>
                                <TextField
                                    id="passport"
                                    label="Enter Passport"
                                    name="passport"
                                    variant="filled"
                                    size="small"
                                    defaultValue={singleCustData.passport}
                                    onChange={(e) => setSingleCustData({
                                        ...singleCustData, passport: e.target.value,
                                    })}
                                    fullWidth
                                />
                            </Grid>
                            {
                                singleCustData.choice === CustRelationChoice.SPOC &&
                                <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="custCompanyName"
                                        label="Enter Company Name"
                                        name="custCompanyName"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.custCompanyName}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, custCompanyName: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }
                            {
                                singleCustData.choice === CustRelationChoice.SPOC &&
                                <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="custGstDetails"
                                        label="Enter GST Details"
                                        name="custGstDetails"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.custGstDetails}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, custGstDetails: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }

                            {
                                singleCustData.choice === CustRelationChoice.RELATIVE && <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="relation"
                                        label="Enter Relation"
                                        name="relation"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.relation}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, relation: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }
                            {
                                singleCustData.choice === CustRelationChoice.SPOC && <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        type="date"
                                        id="custDob"
                                        label="Enter Dob"
                                        name="custDob"
                                        variant="filled"
                                        size="small"
                                        defaultValue={formatDateInReact(singleCustData.custDob)}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, custDob: formatDateInSnp(e.target.value),
                                        })}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            inputProps: {
                                                min: '1913-01-01',
                                                max: formatDateInReact(TODAY_FORMAT_DATE),
                                            },
                                        }}
                                    />
                                </Grid>
                            }
                            {
                                singleCustData.choice === CustRelationChoice.SPOC && <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="custProfession"
                                        label="Enter Customer Profession"
                                        name="custProfession"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.custProfession}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, custProfession: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }
                            {
                                singleCustData.choice === CustRelationChoice.SPOC && <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        id="custFatherName"
                                        label="Enter Fathers Name"
                                        name="custFatherName"
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.custFatherName}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, custFatherName: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }
                            {
                                singleCustData.choice === CustRelationChoice.SPOC &&
                                <Grid item xs={12} md={6} sm={12}>
                                    <TextField
                                        required
                                        id="address"
                                        label="Enter Address"
                                        name="address"
                                        multiline={true}
                                        rows={3}
                                        variant="filled"
                                        size="small"
                                        defaultValue={singleCustData.address}
                                        onChange={(e) => setSingleCustData({
                                            ...singleCustData, address: e.target.value,
                                        })}
                                        fullWidth
                                    />
                                </Grid>
                            }
                            {
                                !isEmpty(singleCustData.mobNo) && <Grid item xs={12}>
                                    <DocumentManager
                                        token={authUser.apiToken}
                                        shopHash={activeShopHash.id}
                                        CustMob={singleCustData.mobNo}
                                    />
                                </Grid>
                            }
                        </Grid>
                    }
                </div>
            </>
        );
    };

    const renderDialogAction = () => {
        return (
            <>
                {
                    ((custForm === 1 || roomForm === 1 || restoForm === 1)
                        && billData.billStatus !== BillStatus.CANCELLED_BILL) && <Button variant="contained" color="primary"
                            onPointerDown={() => {
                                handleSubmitDialog(-1);
                            }} disabled={dialogLoading || billData.paymentInitiated}>
                        {!isEdit ? "Add" : "Update"}
                    </Button>
                }
                {
                    (payForm === 1) && <Button variant="contained" color="primary"
                        onPointerDown={() => handleSubmitDialog(cancelBill ? UiButtonAction.CANCEL_BILL : UiButtonAction.PAY)}
                        disabled={dialogLoading || billData.billStatus === BillStatus.BILLSETTLED
                            || (billData.paymentInitiated && (billData.billStatus === BillStatus.ROOMALLOTEDPAID))}>
                        Pay
                    </Button>
                }
                {
                    cancelBill &&
                    <Button variant="contained" color="primary"
                        onPointerDown={() => handleSubmitDialog(UiButtonAction.CANCEL_BILL)}
                        disabled={dialogLoading || billData.billStatus === BillStatus.BILLSETTLED}>
                        Return
                    </Button>
                }
                {
                    (payForm === 1 && !cancelBill && isFeatureAllowed(authUser.packages, EPAYBILLING)) && <Button variant="contained" color="primary"
                        onPointerDown={() => handleSubmitDialog(UiButtonAction.PAY_WITH_LINK)} disabled={dialogLoading || billData.billStatus === BillStatus.BILLSETTLED || (billData.paymentInitiated
                            && (billData.billStatus === BillStatus.ROOMALLOTEDPAID))}>
                        E-Pay
                    </Button>
                }

                <Button variant="contained" color="primary" onClick={handleDialogClose} disabled={dialogLoading}>
                    Dismiss
                </Button>
            </>
        );
    };


    const renderHeaderForm = () => {
        return (
            <div className="input-bill-number">
                <Grid container spacing={1} sx={{
                    m: 0, p: 0
                }} >

                    {/* <Grid item md={6} xs={12} sm={6}>
                        <Typography variant="p" component="div" className="bill-header" >Room : {billData.catgName+"("+billData.roomNo+")"} </Typography>
                    </Grid> */}
                    <Grid item md={4} xs={12} sm={5}>
                        {/* <Typography variant="p" component="div" className="bill-header" >Check In : {billData.checkInDate} </Typography> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                            <DateTimePicker label="Check In :"
                                readOnly={billData.paymentInitiated || billData.billStatus === BillStatus.CANCELLED_BILL}
                                value={dayjs(billData.checkInDate, 'DD/MM/YYYY HH:mm:ss')}
                                onChange={(e) => {
                                    const cInDate = e?.format("DD/MM/YYYY HH:mm:ss");
                                    let cOutDate = billData.checkoutDate
                                    if (!isSelectedDateStrIsPast(cInDate, cOutDate)) {
                                        cOutDate = addDaysStrDate(cInDate, 1);
                                    }
                                    //checkExistingRoom(true, false, cInDate)
                                    handleFetchAvailableRoom({
                                        isCheckinChange: true,
                                        isOnlyDate: false,
                                        cDate: cInDate,
                                        checkInDate: cInDate,
                                        checkOutDate: cOutDate,
                                    });
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    {
                        !isEmpty(billData.bookingId) &&
                        <Grid item md={6} xs={12} sm={6}>
                            {
                                (isInvoiceAllowed && !isEmpty(billData.invoiceId)) ?
                                    <Typography variant="p" component="div" className="bill-header">{`Booking Id # ${billData.bookingId}/Invoice: ${prefixBillName}${billData.invoiceId}`}</Typography>
                                    :
                                    <Typography variant="p" component="div" className="bill-header">{`Booking Id # ${billData.bookingId}`}</Typography>
                            }

                        </Grid>
                    }
                    <Grid item md={1} xs={1} sm={1}>
                        <center>
                            <Tooltip title="Refresh Bill">
                                <RefreshIcon onClick={(e) => getBillData(billData.id, 1)} />
                            </Tooltip>
                        </center>
                    </Grid>
                    <Grid item md={4} xs={12} sm={6}>
                        {/* <TextField
                            type="date"
                            id="checkoutDate"
                            label="Enter Check Out Date"
                            name="checkoutDate"
                            disabled={billData.paymentInitiated}
                            variant="filled"
                            size="small"
                            defaultValue={formatDateInReact(billData.checkoutDate)}
                            onChange={(e) => {
                                let cOutDate = e.target.value;
                                getStayDaysData(cOutDate);
                            }}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: {
                                    min: formatDateInReact(billData.checkoutMinDate),
                                },
                            }}
                        /> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                            <DatePicker label="Select Check Out :"
                                readOnly={billData.paymentInitiated || billData.billStatus === BillStatus.CANCELLED_BILL}
                                value={dayjs(billData.checkoutDate, 'DD/MM/YYYY')}
                                onChange={(e) => {
                                    const cOutDate = e?.format("DD/MM/YYYY");
                                    //checkExistingRoom(false, true, cOutDate);
                                    handleFetchAvailableRoom({
                                        isCheckinChange: false,
                                        isOnlyDate: true,
                                        cDate: cOutDate,
                                        checkInDate: billData.checkInDate,
                                        checkOutDate: cOutDate,
                                    });
                                }}
                                minDate={dayjs(billData.checkInDate, 'DD/MM/YYYY HH:mm:ss').add(1, 'day')}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </div>
        );
    };

    const renderCustomerForm = () => {
        return (
            <div className="billing-data-container">
                <Grid container spacing={1} display="flex" sx={{
                    m: 0, p: 0
                }} >
                    <Grid item md={12} xs={12} sm={12}>
                        <Typography variant="p" component="div" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px", color: "#A52A2A" }}>Customer Form</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} sm={12}>
                        <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "16px", color: "#2f1160" }}>{billData.listCustomerDetailsSize === 0 ? "No Person Added ... " : "Total Persons: " + billData.listCustomerDetailsSize}</p>
                    </Grid>
                    <Grid item md={4} xs={12} sm={4} >
                        <Button variant="contained" color="primary" disabled={billData.paymentInitiated || billData.billStatus === BillStatus.CANCELLED_BILL} onClick={() => {
                            setCustForm(1);
                            if (spocAdded) {
                                setSingleCustData({
                                    ...singleCustData, choice: CustRelationChoice.RELATIVE, relation: "",
                                })
                            }
                        }}>
                            Add New
                        </Button>
                    </Grid>
                    {
                        billData.listCustomerDetailsSize !== 0 && <Grid item md={4} xs={12} sm={4} onClick={() => {
                            setGridType(1);
                        }}>
                            <Button variant="contained" color="primary">
                                View
                            </Button>
                        </Grid>
                    }

                </Grid>
                <DialogBox showDialog={custForm !== 0}
                    title={isEdit ? "Edit Customer" : "Add New Customer"}
                    onClose={handleDialogClose}
                    dialogContent={renderCustDialogContent()}
                    dialogActions={renderDialogAction()} />
            </div>
        );
    };

    const renderRoomForm = () => {
        return (
            <div className="billing-data-container">
                <Grid container spacing={1} display="flex" sx={{
                    m: 0, p: 0
                }} >
                    <Grid item md={12} xs={12} sm={12}>
                        <Typography variant="p" component="div" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px", color: "#A52A2A" }}>Room Form</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} sm={12}>
                        <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "16px", color: "#2f1160" }}>Total Selected Room: {billData.totalHotelRoomDetailsSize}</p>
                    </Grid>
                    <Grid item md={4} xs={12} sm={4}>
                        <Button variant="contained" color="primary" disabled={billData.paymentInitiated || billData.billStatus === BillStatus.CANCELLED_BILL} onPointerDown={() => selectFirstRoom()}>
                            Add New
                        </Button>
                    </Grid>
                    {
                        billData.totalHotelRoomDetails.length > 0 && <Grid item md={4} xs={12} sm={4}>
                            <Button variant="contained" color="primary" onClick={() => {
                                setGridType(0);
                            }}>
                                View
                            </Button>
                        </Grid>
                    }
                </Grid>
                <DialogBox showDialog={roomForm !== 0}
                    title={isEdit ? "Edit Room" : "Add Room"}
                    onClose={handleDialogClose}
                    dialogContent={renderRoomDialogContent()}
                    dialogActions={renderDialogAction()} />
            </div>
        );
    };


    const renderRestaurantForm = () => {
        return (
            <div className="billing-data-container">
                <Grid container spacing={1} display="flex" sx={{
                    m: 0, p: 0
                }} >
                    <Grid item md={12} xs={12} sm={12}>
                        <Typography variant="p" component="div" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px", color: "#A52A2A" }}>Restaurant Form</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} sm={12}>
                        <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "16px", color: "#2f1160" }}>{billData.restaurantBillIdsSize === 0 ? "No Food Bill Added ... " : "Total Food Bill: " + billData.restaurantBillIdsSize}</p>
                    </Grid>
                    {/* <Grid item md={2} xs={12} sm={4}>
                        <Button variant="contained" color="primary">
                            Add Food Item
                        </Button>
                    </Grid> */}
                    <Grid item md={4} xs={12} sm={4}>
                        <Button variant="contained" color="primary" onClick={() => {
                            setGridType(2);
                        }}>
                            View
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    };

    const payButtonName = () => {
        let btnName = "Add Pay Method";
        if ((billData.billStatus === BillStatus.ROOMALLOTEDPARTIALPAID || billData.billStatus === BillStatus.BILLSETTLEDBUTINDUES))
            btnName = "Clear Dues (" + RESYMBOL + " " + billData.pendingAmt + ")";
        return btnName;
    }

    const renderPayForm = () => {
        return (
            <div className="pay-screen">
                <Grid container spacing={1} display="flex" sx={{ p: 2, m: 2 }}>
                    <Grid item md={7} xs={12} sm={6}>
                        <Grid container spacing={1}>
                            {
                                billData.billStatus === BillStatus.CANCELLED_BILL &&
                                <Grid item xs={12}>
                                    <center>
                                        <Typography variant="subtitle4" component="div"
                                            style={{
                                                fontWeight: 'bold', fontSize: '26px',
                                                color: "#751500", whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                            }}>
                                            This bill is cancelled</Typography>
                                    </center>
                                </Grid>
                            }
                            <Grid item xs={6} md={4} sm={4}>
                                <Typography variant="subtitle4"
                                    component="div"
                                    style={{
                                        fontWeight: 'bold', fontSize: '16px',
                                        color: "#2f1160", whiteSpace: 'pre-wrap',
                                        overflowWrap: 'break-word'
                                    }}>
                                    T. Room Price: ₹{billData.totalRoomPrice}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={4} sm={4}>
                                <Typography variant="subtitle4" component="div"
                                    style={{
                                        fontWeight: 'bold', fontSize: '16px',
                                        color: "#2f1160", whiteSpace: 'pre-wrap',
                                        overflowWrap: 'break-word'
                                    }}>
                                    T. Extra Price: ₹{billData.totalExtraPrice}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={4} sm={4}>
                                <Typography variant="subtitle4" component="div"
                                    style={{
                                        fontWeight: 'bold', fontSize: '16px',
                                        color: "#2f1160", whiteSpace: 'pre-wrap',
                                        overflowWrap: 'break-word'
                                    }}>
                                    T. Restaurant Price: ₹{
                                        (billData.totalRestaurantBillPaidPrice + billData.totalRestaurantBillPrice)
                                    }</Typography>
                            </Grid>
                            <Grid item md={12} sm={12} />
                            <Grid item md={3} xs={6} sm={3}>
                                <FormControl>
                                    <FormLabel id="gstOption">GST Options:</FormLabel>
                                    <FormControlLabel name="isGstAllowed" disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID} checked={billData.gstAllowed} control={<Checkbox />} onChange={() => {
                                        const val = !billData.gstAllowed;
                                        if (val) {
                                            doTotal(billData.takenDenom, billData.takenOffrAmt, cgstConfig, sgstConfig, true, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                        } else {
                                            doTotal(billData.takenDenom, billData.takenOffrAmt, 0.0, 0.0, false, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                        }
                                    }} label={billData.gstAllowed ? "Disable GST" : "Enable GST"} />
                                </FormControl>
                            </Grid>

                            {
                                billData.gstAllowed && <Grid item md={4} xs={6} sm={4}>
                                    <TextField
                                        id="cgst"
                                        label="Enter CGST(%)"
                                        type="number"
                                        name="cgst"
                                        value={cgst}
                                        disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID}
                                        variant="filled"
                                        size="small"
                                        onChange={(e) => {
                                            if (!isNumberEmpty(e.target.value))
                                                doTotal(billData.takenDenom, billData.takenOffrAmt, Number(e.target.value), sgst, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                            else
                                                doTotal(billData.takenDenom, billData.takenOffrAmt, 0.0, sgst, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                        }}
                                        fullWidth
                                        inputProps={{ min: '0' }}
                                    />
                                </Grid>
                            }
                            {
                                billData.gstAllowed && <Grid item md={4} xs={6} sm={4}>
                                    <TextField
                                        id="sgst"
                                        label="Enter SGST(%)"
                                        type="number"
                                        name="sgst"
                                        value={sgst}
                                        disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID}
                                        variant="filled"
                                        size="small"
                                        onChange={(e) => {
                                            if (!isNumberEmpty(e.target.value))
                                                doTotal(billData.takenDenom, billData.takenOffrAmt, cgst, Number(e.target.value), billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                            else
                                                doTotal(billData.takenDenom, billData.takenOffrAmt, cgst, 0.0, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                        }}
                                        fullWidth
                                        inputProps={{ min: '0' }}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12} md={12} sm={9}>
                                <FormControl>
                                    <FormLabel id="billOffer">Any Offer :</FormLabel>
                                    <RadioGroup row aria-label="bofferDenom" name="bofferDenom" disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID} value={billData.takenDenom} onChange={(e) => {
                                        if (!isNumberEmpty(e.target.value))
                                            doTotal(Number(e.target.value), billData.takenOffrAmt, cgst, sgst, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                        else
                                            doTotal(OfferType.No_Offer, billData.takenOffrAmt, cgst, sgst, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                    }
                                    }>
                                        <FormControlLabel value={OfferType.No_Offer} disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID} control={<Radio />} label="No Offer" />
                                        <FormControlLabel value={OfferType.Flat} disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID} control={<Radio />} label="Flat" />
                                        <FormControlLabel value={OfferType.Percentage} disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID} control={<Radio />} label="In Percentage" />
                                        {
                                            (billData.takenDenom > 1) &&
                                            <div>
                                                <TextField
                                                    id="bofferAmt"
                                                    name="bofferAmt"
                                                    variant="filled"
                                                    size="small"
                                                    label="Enter Offer Value"
                                                    disabled={billData.billStatus >= BillStatus.ROOMALLOTEDPAID}
                                                    value={billData.takenOffrAmt}
                                                    onChange={(e) => {
                                                        if (!isNumberEmpty(e.target.value))
                                                            doTotal(billData.takenDenom, Number(e.target.value), cgst, sgst, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                                        else
                                                            doTotal(billData.takenDenom, 0.0, cgst, sgst, billData.gstAllowed, billData.totalDaysStay, billData.checkoutDate, billData.checkInDate);
                                                    }}
                                                    style={{ width: "100%" }}
                                                />
                                            </div>
                                        }
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item md={4} xs={12} sm={5}>
                                {/* <Typography variant="p" component="div" className="bill-header" >Check In : {billData.checkInDate} </Typography> */}
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                    <DateTimePicker label="Actual Check In :"
                                        readOnly={billData.status === BillStatus.BILLSETTLED || billData.billStatus === BillStatus.CANCELLED_BILL}
                                        value={dayjs(keyMapInformation.get(ACTUAL_CHECK_IN) ?? "", 'DD/MM/YYYY HH:mm:ss')}
                                        onChange={(e) => {
                                            const cInDate = e?.format("DD/MM/YYYY HH:mm:ss");
                                            setKeyMapInformation(prev => {
                                                const newMap = new Map(prev);
                                                newMap.set(ACTUAL_CHECK_IN, cInDate);
                                                return newMap;
                                            })
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item md={4} xs={12} sm={5}>
                                <TextField
                                    variant="filled"
                                    size="small"
                                    disabled={billData.billStatus === BillStatus.CANCELLED_BILL}
                                    label="Order Via"
                                    onChange={(e) => setKeyMapInformation(prev => {
                                        const newMap = new Map(prev);
                                        newMap.set(ORDER_FROM, e.target.value);
                                        return newMap;
                                    })}
                                    value={keyMapInformation.get(ORDER_FROM) ?? ""}
                                />
                            </Grid>
                            <Grid item md={4} xs={12} sm={5}>
                                <TextField
                                    variant="filled"
                                    disabled={billData.billStatus === BillStatus.CANCELLED_BILL}
                                    size="small"
                                    label="Order Via Id"
                                    onChange={(e) => setKeyMapInformation(prev => {
                                        const newMap = new Map(prev);
                                        newMap.set(ORDER_FROM_ID, e.target.value);
                                        return newMap;
                                    })}
                                    value={keyMapInformation.get(ORDER_FROM_ID) ?? ""}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={6}>
                                <TextField
                                    id="remarks"
                                    label="Enter Remarks/FeedBack"
                                    name="remarks"
                                    multiline={true}
                                    rows={3}
                                    disabled={billData?.billStatus === BillStatus.BILLSETTLED}
                                    variant="filled"
                                    size="small"
                                    defaultValue={billData?.remarks ?? ""}
                                    onChange={(e) => setBillData(prev => ({
                                        ...prev,
                                        remarks: e.target.value
                                    }))}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6} sm={6}>
                                <TextField
                                    id="reason"
                                    label="Enter Reason"
                                    name="reason"
                                    multiline={true}
                                    rows={3}
                                    disabled={billData?.billStatus === BillStatus.BILLSETTLED}
                                    variant="filled"
                                    size="small"
                                    defaultValue={billData?.reason ?? ""}
                                    onChange={(e) => setBillData(prev => ({
                                        ...prev,
                                        reason: e.target.value
                                    }))}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={5} xs={12} sm={6}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Total Days Stay: {billData.totalDaysStay}</Typography>
                            </Grid>
                            <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Sub Total: ₹{billData.totalPrice + billData.totalRestaurantBillPaidPrice}</Typography>
                            </Grid>
                            {
                                billData.takenDenom === OfferType.Flat && <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "rgb(189, 116, 67)", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Offer Applied {"(- Flat )"} {billData.takenOffrAmt}</Typography>
                                </Grid>
                            }
                            {
                                billData.takenDenom === OfferType.Percentage && <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "rgb(189, 116, 67)", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Offer Applied {"(-)"} {billData.takenOffrAmt} %</Typography>
                                </Grid>
                            }
                            {
                                billData.gstAllowed && <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >CGST{"(" + cgst + "%):"} ₹{billData.cgstAmt}</Typography>
                                </Grid>
                            }

                            {
                                billData.gstAllowed && <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >SGST{"(" + sgst + "%):"} ₹{billData.sgstAmt}</Typography>
                                </Grid>
                            }
                            {
                                (billData.roundOff !== 0.0 || billData.roundOff !== -0.0) &&
                                <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#A52A2A", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >RoundOff{billData.roundOff > 0.0 ? "(+)" : "(-)"} {billData.roundOff}</Typography>
                                </Grid>
                            }
                            <Grid item xs={12} md={12} sm={12}>
                                <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Grand Total: ₹{(billData.finalPrice + billData.totalRestaurantBillPaidPrice)}</Typography>
                            </Grid>
                            {
                                billData.billStatus !== BillStatus.CANCELLED_BILL &&
                                <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Paid Amount: ₹{billData.paidAmt}</Typography>
                                </Grid>
                            }
                            {
                                billData.pendingAmt > 0.0 && <Grid item xs={12} md={12} sm={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Dues: ₹{billData.pendingAmt}</Typography>
                                </Grid>
                            }
                            {
                                billData.billStatus === BillStatus.CANCELLED_BILL &&
                                <Grid item xs={12}>
                                    <Typography variant="subtitle4" component="div"
                                        style={{
                                            fontWeight: 'bold', fontSize: '25px',
                                            color: "#751500", whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                                        }}>
                                        This bill is cancelled</Typography>
                                </Grid>
                            }
                            {
                                !isEmpty(billData.finalCheckoutDate) && <Grid item xs={12}>
                                    <Typography variant="subtitle4" component="div" style={{ fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Final CheckOut: {billData.finalCheckoutDate}</Typography>
                                </Grid>
                            }
                            <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" disabled={billData.totalPrice === 0 || billData.billStatus >= BillStatus.BILLSETTLED} color="primary"
                                    onPointerDown={() => handleSubmitData(UiButtonAction.SAVE_BILL)}>
                                    Save Bill
                                </Button>
                            </Grid>
                            <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" disabled={billData.totalPrice === 0} color="primary"
                                    onPointerDown={() => handleSubmitData(UiButtonAction.PRINT)}>
                                    Print Bill
                                </Button>
                            </Grid>
                            <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" disabled={billData.totalPrice === 0 || billData.billStatus === BillStatus.INUI
                                    || billData.billStatus === BillStatus.ROOMALLOTEDPAID ||
                                    billData.billStatus === BillStatus.BILLSETTLED
                                    || billData.billStatus === BillStatus.CANCELLED_BILL
                                } color="primary" onClick={() => {
                                    setPayForm(1);
                                    setCancelBill(false);
                                    if (billData.billStatus === BillStatus.ROOMALLOTEDNOTPAID) {
                                        setBillData({
                                            ...billData, billStatus: BillStatus.ROOMALLOTEDPARTIALPAID,
                                        })
                                    }
                                }}>
                                    {payButtonName()}
                                </Button>
                            </Grid>
                            {
                                billData?.paymentInitiated && <Grid item md={6} xs={12} sm={6}>
                                    <Button variant="contained" color="primary" onClick={() => {
                                        setShowPaymentListDialog(true);
                                    }}>
                                        Check Payment Status
                                    </Button>
                                </Grid>
                            }
                            {
                                isFeatureAllowed(authUser.packages, CANCEL_BILL_MANAGEMENT) &&
                                <Grid item md={6} xs={12} sm={6}>
                                    <Button variant="contained" disabled={
                                        billData.totalPrice === 0 || billData.billStatus === BillStatus.INUI
                                        || billData.billStatus === BillStatus.BILLSETTLED
                                        || billData.billStatus === BillStatus.CANCELLED_BILL} color="primary"
                                        onPointerDown={() => {
                                            if (isRoleAllowed(BOOKINGCANCEL)) {
                                                if (billData.billStatus === BillStatus.ROOMALLOTEDNOTPAID) {
                                                    handleSubmitData(UiButtonAction.CANCEL_BILL);
                                                } else {
                                                    setPayForm(1);
                                                    setCancelBill(true);
                                                    setPartialPay(prev => ({
                                                        ...prev,
                                                        partialAmt: billData.paidAmt,
                                                    }))
                                                }
                                            }
                                        }}>
                                        Cancel Bill
                                    </Button>
                                </Grid>
                            }

                            <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained" disabled={billData.paymentInitiated || billData.billStatus === BillStatus.CANCELLED_BILL} color="primary" onClick={deleteEntireBill}>
                                    Delete Bill
                                </Button>
                            </Grid>
                            <Grid item md={6} xs={12} sm={6}>
                                <Button variant="contained"
                                    disabled={
                                        billData.billStatus <= BillStatus.ROOMALLOTEDNOTPAID
                                        || billData.billStatus >= BillStatus.BILLSETTLED
                                        || billData.billStatus === BillStatus.CANCELLED_BILL
                                    }
                                    color="primary"
                                    onPointerDown={() => handleSubmitData(UiButtonAction.SETTLE)}>
                                    {billData.billStatus >= BillStatus.BILLSETTLED ? "Already Settled" : "Settle Bill"}
                                </Button>
                            </Grid>
                            {
                                (billData?.restaurantBillIds?.length ?? 0) > 0 &&
                                <Grid item md={6} xs={12} sm={6}>
                                    <Button variant="contained" disabled={billData.totalPrice === 0 || snpLoader} color="primary" onPointerDown={() => handleSubmitData(UiButtonAction.PRINT, true)}>
                                        Print Detailed Bill
                                    </Button>
                                </Grid>
                            }
                            {
                                (billData.restaurantBillIdsSize > 0 &&
                                    (billData.billStatus === BillStatus.ROOMALLOTEDPAID
                                        || billData.billStatus === BillStatus.BILLSETTLED))
                                &&
                                <Grid item md={6} xs={12} sm={6}>
                                    <Button variant="contained" disabled={snpLoader} color="primary"
                                        onPointerDown={() => generateSplitBill()}>
                                        Split Food Bill
                                    </Button>
                                </Grid>
                            }

                        </Grid>
                    </Grid>
                </Grid>
                <DialogBox showDialog={payForm !== 0}
                    title={"Add Pay Method"}
                    onClose={handleDialogClose}
                    dialogContent={renderPayDialogForm()}
                    dialogActions={renderDialogAction()} />
            </div>
        );
    };



    const getPartialPaidThrough = (val) => {
        if (val.payMedium === PayMedium.BOTH) {
            return val.onlineBillPaidThrough + "(" + val.onlinePay + ") Cash(" + val.cashPay + ")";
        } else if (val.payMedium === PayMedium.ONLINE)
            return val.onlineBillPaidThrough;
        else
            return "Cash";
    };

    const handleSetPayingAmount = (amount) => {
        const value = Number(amount);
        if (!isNumberEmpty(value)) {
            if (value > billData.pendingAmt) {
                setSnpComponent({
                    ...snpComponent,
                    snackBarOpen: true,
                    snackBarMsg: "Exceeds Remaining Amt i.e " + billData.pendingAmt,
                });
                setPartialPay({
                    ...partialPay,
                    partialAmt: 0, onlineBillPaidThrough: "", onlinePay: 0, payMedium: PayMedium.NOT_SELECTED, cashPay: 0, cashTendered: 0, cashReturn: 0,
                });
            } else {
                const dues = billData.pendingAmt - value;
                setPartialPay({
                    ...partialPay,
                    partialAmt: value, onlineBillPaidThrough: "", onlinePay: 0, payMedium: PayMedium.NOT_SELECTED, cashPay: 0, cashTendered: 0, cashReturn: 0,
                });
                setBillData({
                    ...billData,
                    duesAmt: dues
                });
            }
        } else {
            setPartialPay({
                ...partialPay,
                partialAmt: value, onlineBillPaidThrough: "", onlinePay: 0, payMedium: PayMedium.NOT_SELECTED, cashPay: 0, cashTendered: 0, cashReturn: 0,
            });
            setBillData({
                ...billData,
                duesAmt: 0
            });
        }
    };


    const renderPayDialogForm = () => {
        return (
            <Paper
                elevation={2}
                sx={{
                    padding: 2,
                    maxWidth: 600,
                    margin: "auto",
                    borderRadius: 2,
                    backgroundColor: cancelBill ? "#edd9b7" : "#fff",
                }}
            >
                <Grid container spacing={2} alignItems="center">
                    {/* Grand Total */}
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Grand Total:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="primary" fontWeight="bold">
                            ₹ {(billData.finalPrice + billData.totalRestaurantBillPaidPrice)}
                        </Typography>
                    </Grid>

                    {/* Remaining Amt To Paid */}
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Remaining Amt To Paid:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="secondary" fontWeight="bold">
                            ₹ {billData.pendingAmt}
                        </Typography>
                    </Grid>
                    {/* Current Remaining Dues */}
                    {!cancelBill &&
                        <Grid item xs={6}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Current Remaining Dues:
                            </Typography>
                        </Grid>
                    }
                    {
                        !cancelBill &&
                        <Grid item xs={6}>
                            <Typography variant="body1" color="error" fontWeight="bold">
                                ₹ {billData.duesAmt}
                            </Typography>
                        </Grid>
                    }
                    {/* Enter Paying Amount (TextField) */}
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {cancelBill ? "Return Amount" : "Enter Paying Amount:"}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            disabled={cancelBill}
                            value={partialPay?.partialAmt ?? 0}
                            onChange={(e) => handleSetPayingAmount(e.target.value)}
                            placeholder="Enter amount"
                        />
                    </Grid>
                    {/* Payment Methods */}
                    <Grid item xs={12}>
                        <FormLabel id="paymentMethod">Payment Methods:</FormLabel>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel name="onlinePay" value={""} checked={partialPay.payMedium === PayMedium.ONLINE || partialPay.payMedium === PayMedium.BOTH}
                            control={<Checkbox />} label="Online"
                            onChange={() => {
                                if (partialPay.payMedium === PayMedium.ONLINE) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: "", payMedium: PayMedium.NOT_SELECTED,
                                        onlinePay: 0.0
                                    })
                                } else if (partialPay.payMedium === PayMedium.CASH) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: authUser.onlinePayMethod[0], payMedium: PayMedium.BOTH,
                                        onlinePay: (partialPay.partialAmt / 2), cashPay: (partialPay.partialAmt / 2),
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else if (partialPay.payMedium === PayMedium.BOTH) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: "", payMedium: PayMedium.CASH,
                                        onlinePay: 0.0, cashPay: partialPay.partialAmt,
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: authUser.onlinePayMethod[0], payMedium: PayMedium.ONLINE,
                                        onlinePay: (partialPay.partialAmt)
                                    })
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Search Online Pay Method:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="pOnline-select"
                            options={authUser.onlinePayMethod}
                            autoHighlight
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium === PayMedium.CASH || partialPay.payMedium === PayMedium.NOT_SELECTED}
                            isOptionEqualToValue={(option, value) => option === value}
                            getOptionLabel={(option) => option}
                            onChange={(e, opt) => {
                                if (opt) {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: opt,
                                    });
                                } else {
                                    setPartialPay({
                                        ...partialPay, onlineBillPaidThrough: "",
                                    })
                                }
                            }}
                            value={partialPay.onlineBillPaidThrough}
                            defaultValue={partialPay.onlineBillPaidThrough}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    {...props}
                                >
                                    {option}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{
                                        ...params.inputProps,
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Enter Online Amount:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="onlinePayAmt"
                            name="onlinePayAmt"
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium !== PayMedium.BOTH}
                            value={partialPay.onlinePay}
                            onChange={(e) => {
                                if (partialPay.payMedium === PayMedium.BOTH) {
                                    let val = Number(e.target.value);
                                    if (val > partialPay.partialAmt) {
                                        setSnpComponent(prev => ({
                                            ...prev, snackBarMsg: "Exceed Total Amt " + RESYMBOL + " " + partialPay.partialAmt,
                                            snackBarOpen: true,
                                        }))
                                    } else {
                                        let cPay = partialPay.partialAmt - val;
                                        setPartialPay({
                                            ...partialPay,
                                            onlinePay: val, cashPay: cPay,
                                            cashTendered: 0.0, cashReturn: 0.0,
                                        })
                                    }

                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel name="cashPay" value={""} checked={partialPay.payMedium === PayMedium.CASH || partialPay.payMedium === PayMedium.BOTH}
                            control={<Checkbox />} label="Cash"
                            onChange={() => {
                                if (partialPay.payMedium === PayMedium.CASH) {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.NOT_SELECTED,
                                        cashPay: 0.0, cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else if (partialPay.payMedium === PayMedium.ONLINE) {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.BOTH,
                                        onlinePay: (partialPay.partialAmt / 2), cashPay: (partialPay.partialAmt / 2),
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else if (partialPay.payMedium === PayMedium.BOTH) {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.ONLINE,
                                        cashPay: 0.0, onlinePay: partialPay.partialAmt,
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                } else {
                                    setPartialPay({
                                        ...partialPay, payMedium: PayMedium.CASH,
                                        cashPay: (partialPay.partialAmt),
                                        cashTendered: 0.0, cashReturn: 0.0,
                                    })
                                }
                            }} />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Enter Cash Amount:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="cashPayAmt"
                            name="cashPayAmt"
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium !== PayMedium.BOTH}
                            value={partialPay.cashPay}
                            onChange={(e) => {
                                if (partialPay.payMedium === PayMedium.BOTH) {
                                    let val = Number(e.target.value);
                                    if (val > partialPay.partialAmt) {
                                        setSnpComponent(prev => ({
                                            ...prev,
                                            snackBarOpen: true,
                                            snackBarMsg: "Exceed Total Amt " + RESYMBOL + " " + partialPay.partialAmt,
                                        }));
                                    } else {
                                        let oPay = partialPay.partialAmt - val;
                                        setPartialPay({
                                            ...partialPay,
                                            cashPay: val, onlinePay: oPay,
                                            cashTendered: 0.0, cashReturn: 0.0,
                                        })
                                    }

                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Enter Cash Tender:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="cashTender"
                            name="cashTender"
                            variant="filled"
                            size="small"
                            fullWidth
                            disabled={partialPay.payMedium === PayMedium.ONLINE || partialPay.payMedium === PayMedium.NOT_SELECTED}
                            value={partialPay.cashTendered}
                            onChange={(e) => {
                                const val = Number(e.target.value) ?? 0.0;
                                let cReturn = 0.0;
                                if (val >= partialPay.cashPay) {
                                    cReturn = val - partialPay.cashPay;
                                    setPartialPay({
                                        ...partialPay,
                                        cashTendered: val, cashReturn: cReturn,
                                    })
                                } else {
                                    setPartialPay({
                                        ...partialPay,
                                        cashTendered: val, cashReturn: 0.0,
                                    })
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Cash Return:
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body1" color="primary" fontWeight="bold">
                            ₹ {(partialPay?.cashReturn ?? 0)}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="remarks"
                            label="Enter Remarks/FeedBack"
                            name="remarks"
                            multiline={true}
                            rows={3}
                            disabled={billData?.billStatus === BillStatus.BILLSETTLED}
                            variant="filled"
                            size="small"
                            defaultValue={partialPay?.remarks ?? ""}
                            onChange={(e) => setPartialPay({
                                ...partialPay, remarks: e.target.value,
                            })}
                            fullWidth
                        />
                    </Grid>

                </Grid>
            </Paper>
        );
    }

    const renderBookingForm = () => {
        return (
            <>
                <div className="billing-data-grid-container">
                    {renderRoomForm()}
                    {renderCustomerForm()}
                    {renderRestaurantForm()}
                </div>
            </>
        );
    }

    function renderPaymentListDialogForm() {
        return (
            <>
                {billData?.lpatialAmt?.length > 0 &&
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table" className="rate_card">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Paid On</TableCell>
                                    <TableCell align="center">Pay Type</TableCell>
                                    <TableCell align="center">Accept By</TableCell>
                                    <TableCell align="center">Amount</TableCell>
                                    <TableCell align="center">Paid Through</TableCell>
                                    <TableCell align="center">Remarks</TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {billData?.lpatialAmt.map((val) => {
                                    return (
                                        <>
                                            <TableRow
                                                className="rate_card--row"
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 },
                                                    border: !val.credit ? '2px solid red' : 'none', // outer red border
                                                    borderRadius: 2, // optional: round corners
                                                    '& > *': { borderBottom: 'none' }, // removes inner cell borders
                                                }}>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{val.paidOn}</p></TableCell>
                                                <TableCell align="center"><p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word', color: val.credit ? "#87a96b" : "#990000"
                                                }}>{val.credit ? "Pay to customer" : "Returned to customer"}</p></TableCell>
                                                <TableCell align="center">{val.paidAcceptBy}</TableCell>
                                                <TableCell align="center">{val.partialAmt}</TableCell>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{getPartialPaidThrough(val)}</p></TableCell>
                                                <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "9px" }}>{val.remarks}</p></TableCell>
                                                {
                                                    (val.canDelete ?? false) &&
                                                    <TableCell align="center">
                                                        <IconButton
                                                            size="small"
                                                            aria-label="delete"
                                                            onPointerDown={() => {
                                                                setShowPaymentListDialog(false);
                                                                handlePermanentDeleteUnpaidBill(val.id);
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                            {
                                                !isEmpty(val?.thirdPartyTransaction?.bank_transactionId) &&
                                                <Typography variant="p"
                                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px", color: "#053514ff", p: 1 }}>
                                                    {"Transaction Id : " + (val?.thirdPartyTransaction?.bank_transactionId).replace("pay_", "")}
                                                </Typography>
                                            }
                                        </>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </>
        )
    }

    const renderSnpContent = () => {
        return (
            <>
                <div>
                    <div>{renderHeaderForm()}</div>
                    <div>{renderBookingForm()}</div>
                    {
                        gridType === 0 &&
                        <div><CustomDataGrid
                            getRowId={row => row.id}
                            title={GRIDARRAY[gridType]}
                            rows={billData.totalHotelRoomDetails}
                            columns={COLUMN_HOTELS}
                        /></div>
                    }
                    {
                        gridType === 1 &&
                        <div><CustomDataGrid
                            getRowId={row => row.mobNo}
                            title={GRIDARRAY[gridType]}
                            rows={billData.listCustomerDetails}
                            columns={COLUMN_CUSTOMER}
                        /></div>
                    }
                    {
                        gridType === 2 &&
                        <div><CustomDataGrid
                            getRowId={row => row.billNo}
                            title={GRIDARRAY[gridType]}
                            rows={billData.restaurantBillIds}
                            columns={COLUMN_RESTO}
                        /></div>
                    }

                    <div>{renderPayForm()}</div>
                    <RoomTableData
                        dialog={showRoomTableDialog}
                        billingDataList={removedObjects}
                        billData={billData}
                        handleOnClickRemove={handleOnClickRemove}
                    />
                    <DialogBox showDialog={showPaymentListDialog}
                        title={"Payment Status"}
                        onClose={() => {
                            setShowPaymentListDialog(false);
                        }}
                        dialogContent={renderPaymentListDialogForm()}
                        dialogActions={renderDialogAction()} />
                </div>
            </>
        );
    };

    return (
        <>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                isLoader={snpLoader}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                iconReq={snpComponent.iconReq}
                iconContent={snpComponent.iconContent}
                content={renderSnpContent()}
                onSnackClose={() => setSnpComponent({
                    ...snpComponent,
                    snackBarOpen: false,
                    snackBarMsg: "",
                })}
                handleSubmit={snpComponent.handleSnpSubmit}
                onCancel={snpComponent.handleSnpCancel}
                cancelExtra={snpComponent.cancelExtra}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                snackDuration={5000}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </>
    );

}